import React,{useState,useEffect,useRef} from 'react';
import ArtistPgImg2 from './../../../images/artistpgimg2.png'
import ArtistPgImg3 from './../../../images/artistpgimg3.png'
import ArtistPgImg3Tab from './../../../images/ArtistPgImg3Tab.png'
import ArtistPgImg5 from './../../../images/artistpgimg5.png'
import NervousLogo from './../../../images/nervouslogo.png'
import Etop from './../../../images/Etop.png'
import Ebottom from './../../../images/Ebottom.png'
import EArtistPage from './../../../images/EartistPage.png'
import NervousPlusLogo from './../../../images/nervouspluslogo.png'
import NerveProLogo from './../../../images/nerveprologo.png'
import InviteOnlyLogo from './../../../images/inviteonlylogo.png'
import CheckCircle from './../../../images/checkcircle.png'
import MostPopular from './../../../images/mostpopularbox.png'
import CompareFeaturesBox from './../../../images/comparefeatureborder.png'
import CompareCheck from './../../../images/comparecheck.png'
import ArtistDots1 from './../../../images/artistdots1.png'
import CarouselBackIcon from './../../../images/carouselbackicon.png'
import CarouselNextIcon from './../../../images/carouselnexticon.png'
import ArtistDots2 from './../../../images/artistdots2.png'
import ArtistDots3 from './../../../images/artistdots3.png'
import ArtistDots4 from './../../../images/artistdots4.png'
import ArtistDots5 from './../../../images/artistdots5.png'
import ArtistDots6 from './../../../images/artistdot6.png'
import ArtistDots7 from './../../../images/artistdots7.png'
import ArtistBanner from './../../../images/artistpgbanner2.png'
import GreyFlower from './../../../images/greyflower.png'
import ArtistMonetizeBanner from './../../../images/artistmonetizebanner.png'
import ArtistPublishBanner from './../../../images/artistpublishingbanner.png'
import ArtistBanner3Dots1 from './../../../images/artistpgbanner3dots1.png'
import ArtistBanner3Dots2 from './../../../images/artistpgbanner3dots2.png'
import PurpleFlower from './../../../images/purpleflower.png'
import artistwhychoose from './../../../images/artistwhychoose.png'
import ArtistStepTarget from './../../../images/artiststeptarget.png'
import LaunchMusicBanner from './../../../images/launchmusicbanner.png'
import HowItWorksGraphic from './../../../images/howitworksgraphic.png'
import Questionaire from './Questionaire';
import QuestionaireClosedBg from './../../../images/questionaireclosedbg.png'
import QuestionareResultBg from './../../../images/questionaireresultbg.png'
import N3rvePlan from './N3rvePlan';
import carouselwhitedots from './../../../images/carouselwhitedots.png'
import carouselnervelogo from './../../../images/carouselnervelogo.png'
import carouselreddots from './../../../images/carouselreddots.png'
import carouselgridlines from './../../../images/carouselgridlines.png'
import artistcarouselrlines1 from './../../../images/artistcarouselrlines1.png'
import artistcarouselrlines2 from './../../../images/artistcarouselrlines2.png'
import carouselimageboundary from './../../../images/carouselimageboundary.png'
import carouseltworeddots from './../../../images/carouseltworeddots.png'
import carouselredlines from './../../../images/carouselredlines.png'
import carouselgreydots from './../../../images/carouselgreydots.png'
import ProdcerDots2 from './../../../images/producerdots2.png'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import N3rveLogo from "./../../../images/N3rveLogo.png"
import crossicon from './../../../images/crossicon.png'
import AA from './../../../images/aa.png'
import ComparePlanCheck from './../../../images/compareplancheck.png'
import CompareFeatureBorder from './../../../images/comparefeatureborder.png'
import Nervoustick from "./../../../images/nervoustick.png"
import Nerveplustick from "./../../../images/nerveplustick.png"
import Nerveprotick from "./../../../images/nerveprotick.png"
import JoinUsBtn from './../../../images/joinusbtn.png'
import JoinUsBtnwithTxt from './../../../images/joinuswithtxtbtn.png'
import DisclaimerIcon from './../../../images/disclaimerpopup.png'
import JoinNerveBtn from './../../../images/getstartedbtn.png'
import ArtistDetailsCheckbox from './../../../images/artistdetailscheckbox.png'
import ArtistCarouselNerveLogo from './../../../images/artistcarouselnervelogo.png'
import ArtistCarouselLines from './../../../images/artistcarousellines.png'
import ArtistCarouselSq from './../../../images/artistcarouselfoursq.png'
import NerveProCarouselImg from './../../../images/nerveproartistcarousel.png'
import ArrowDown from './../../../images/arrowdown.png'
import CarouselSelectedIcon from './../../../images/carouselselectedicon.png'
import CarouselDeselectedIcon from './../../../images/carouseldeselectedicon.png'
import ReactModal from 'react-modal';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel'
import Footer from '../../Footer/Footer';
import Navbar from '../../Navbar/Navbar';
import { Link } from 'react-router-dom';
import './Artists.css'
import {useLocation,useNavigate} from "react-router-dom";
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import { Parallax, ParallaxLayer} from '@react-spring/parallax'
import nervousplangradient from './../../../images/nervousplangradient.png'
import nerveplusgradient from './../../../images/nerveplusgradient.png'
import nerveprogradient from './../../../images/nerveprogradient.png'
import nexdgradient from './../../../images/nexdgradient.png'
import nexdgradientonly from './../../../images/nexdgradientonly.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";

function Artists() {
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  const [progress1style,setProgress1Style] = useState("PlanProgress1")
  const [carouselItem , setCarouselItem] = useState('#EA4600')
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const [disc1,setDisc1] = useState(false);
  const [disc2,setDisc2] = useState(false);
  const [disc3,setDisc3] = useState(false);
  const [disc4,setDisc4] = useState(false);
  const [disc5,setDisc5] = useState(false);
  const [disc6,setDisc6] = useState(false);
  const [disc7,setDisc7] = useState(false);
  const [disc8,setDisc8] = useState(false);
  const [disc9,setDisc9] = useState(false);
  const [disc10,setDisc10] = useState(false);
  const [plansPopup,setPlansPopup] = useState(false);
  const [questionaire,setQuestionaire] = useState(0);
  const {t, i18n } = useTranslation();
  const cookies = new Cookies(null ,{ path: '/' });
  const [stepOption,setStepOption] = useState(0)
  const location = useLocation();
  const comparePlansRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0); // State to track the active carousel index
  const totalSlides = 4; // Update this based on the number of slides you have
  const [artistno,setArtistNo] = useState(1);
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  const hasLogged = useRef(false);
  
  const prevArtist = () =>{
      if(activeIndex!==0){
          console.log(activeIndex)
          console.log("PlanProgressstepdown".concat(activeIndex))
          setProgress1Style("PlanProgressstepdown".concat(activeIndex))
          setActiveIndex(activeIndex-1)
      }
  
  }


    const nextArtist = () =>{

        if(activeIndex!==3){
            console.log(artistno)
            setProgress1Style("PlanProgressstepup".concat(activeIndex+1))
            setActiveIndex(activeIndex+1)
        }
    }

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

    // Scroll handler
    const handleScroll = (event) => {

        event.preventDefault(); // Prevent default scroll behavior
        event.stopPropagation(); // Stop the event from bubbling up

        if (event.deltaY > 0) {
          // Scroll up (previous item)
          setActiveIndex((prevIndex) =>
          prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
        );
        } else {
          // Scroll down (next item)
          setActiveIndex((prevIndex) => (prevIndex + 1) % totalSlides);
        }
     
    };

    
  // const handleScroll = (event) => {
  //   if (event.deltaY > 0) {
  //     carouselRef.current.next();
  //   } else {
  //     carouselRef.current.previous();
  //   }
  // };


  const handleResize = () => {
    console.log(window.innerWidth)
    if(window.innerWidth<1024){
      setPlansPopup(false)
    }
    setDimensions({
    width: window.innerWidth,
    height: window.innerHeight,
    });
  }

  const questionaire_result = (data) => { 
    setQuestionaire(data)
    return data
  }

  function closeModal() {
    setPlansPopup(false);
  }


useEffect(() => {
    // if (location.hash === '#ComparePlans') {
    //   const element = document.getElementById('ComparePlans');
    //   console.log("We in")
    //   console.log(element)
    //   if (element) {
    //     element.scrollIntoView({ behavior: 'smooth' });
    //   }
    // }
    // if (location.hash === '#ComparePlans' && comparePlansRef.current) {
    //   comparePlansRef.current.scrollIntoView({ behavior: 'smooth' });
    // }
    if (location.hash === '#ComparePlans') {
      const intervalId = setInterval(() => {
        const element = document.getElementById('ComparePlans');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          clearInterval(intervalId);
        }
      }, 100); // Check every 100ms

      // Clear the interval if the component unmounts
      return () => clearInterval(intervalId);
    }
}, [location]);

useEffect(() => {
  window.addEventListener("resize", handleResize, false);
  topFunction()
  if (!hasLogged.current) {
   if (cookies.get('token') !== undefined) {
              if (decodeToken(cookies.get('token')) !== null) {
                  logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Page", { "desc": "User opened the artist page" })
                  hasLogged.current = true;
              } else {
                  logtoWix("anonymous user", "pageview", "Artist Page", { "desc": "User opened the artist page" })
                  hasLogged.current = true;
              }
          } else {
              logtoWix("anonymous user", "pageview", "Artist Page", { "desc": "User opened the artist page" })
              hasLogged.current = true;
          }
    }
}, []);

  useEffect(()=>{
    console.log(cookies.get('lang') === 'en' ?  'LandingPgDiv1H1': 'jp-LandingPgDiv1H1')
},[cookies.get('lang')])

  return (
    <div div style={{width:'100vw'}}>
        


        {/* ******************************************** */}


        {/* DESKTOP VIEW */}

        {
            dimensions.width >= 1024 &&
            <div style={{width:'100%',height:'100%',textAlign:'left'}}>
              <Parallax > 
              <ParallaxLayer offset={0} speed={0.4} factor={2} style={{ 
                                    width:'150vw',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'flex-start',
                                    justifyContent:'flex-end',
                                    paddingLeft:'17em',
                                    height:"150vh",
                                    backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/wcabd6brbmabstrnwwvd")`, 
                                    backgroundSize:'cover',
                                    backgroundRepeat:'no-repeat',
                                    backgroundPositionX:'-50vw',
                                    zIndex:'-1'
                                  }}>                          
                               
                                
                            </ParallaxLayer>
                            <div className="ArtistsContainer">
                                <div style={{ 
                                    // backgroundImage:`url(${ArtistPgImg1})`, 
                                    height:'100vh',
                                    // height:'50px',
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    backgroundSize:'cover',
                                    position:'relative'}}>
                                    <div style={{position:'absolute',bottom:'3em',left:'17%'}}>

                                      <div className='ForArtistTxt' style={{alignSelf:'flex-start',marginTop:'0em',marginLeft:'0em',marginBottom:'1em'}}>
                                        {t('ForArtist')}
                                      </div>

                                      <div className='FuelYourMusicTxt' style={{marginTop:'0em',marginLeft:'0em',width:'9em',textAlign:'left',fontSize:'3rem'}}>
                                        <Trans i18nKey="Youryourmusic" components={{1:<br/>}} >
                                        Fuel Your Music, <br/> Shape Your Journey
                                        </Trans>
                                      </div>

                                      <div className='Own100Rights' style={{marginLeft:'0em'}}>
                                        {t('Own100%rights')}
                                      </div>

                                      <div className='ThisIsWhereTxt' style={{width:'35%',marginLeft:'0em'}}>
                                      <Trans i18nKey="Thisiswhereyourmusic" components={{1:<br/>}} >
                                      This is where your music comes alive. Experience a platform<br/> built for artists like you - where resources meet independence,<br/> and creative freedom reigns.<br/>
                                        </Trans>
                                      </div>

                                      <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',cursor:'pointer',justifyContent:'center',zIndex:'5'}} onClick={()=>navigate("/Signup")}>
                                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                        <div className="TestMedium">
                                        {t('Getstarted')}
                                        <div className="HoverOverlay" />
                                        </div>
                                      </div>

                                      <img src={ProdcerDots2} style={{width:'5.5em',height:'0.18em',marginTop:'1.5em'}}/>

                                    </div>
       
                            </div>

                  
                   
                      {/* <img src={Ebottom} style={{position:'absolute',width:'38.708em',height:'40.44em',top:'95.48em',right:'0em'}}/> */}

                    
                     


                      <div style={{width:dimensions.width,height:'57.625em',backgroundColor:'#15171B',display:'flex',flexDirection:'row',alignItems:'center', backgroundSize:'cover',overflow:'hidden',position:'relative'}}>
                      {/* <img src={EArtistPage} style={{position:'absolute',width:'31.75em',height:'38.47em',top:'-5em',right:'5em',zIndex:'0'}}/> */}
                      <img src={ArtistDots1} style={{position:'absolute',width:'1.48em',height:'26.83em',top:'4em',left:'1em',zIndex:'1'}}/>
                        {/* <img src={carouselwhitedots} style={{position:'absolute',width:'0.58em',height:'5.695em',left:'1em',top:'97.75em'}}/>
                        <img src={carouselnervelogo} style={{position:'absolute',width:'1.48em',height:'26.838em',left:'2.5em',top:'90.18em'}}/>
                        <img src={carouselreddots} style={{position:'absolute',width:'1.82em',height:'3.51em',left:'0em',top:'125.87em'}}/>
                        <img src={carouselgreydots} style={{position:'absolute',width:'0.388em',height:'4.88em',right:'1em',top:'120.87em'}}/>
                        <img src={carouselredlines} style={{position:'absolute',width:'1.49em',height:'29.96em',right:'5em',top:'95.87em'}}/>
                        <img src={carouseltworeddots} style={{position:'absolute',width:'1.12em',height:'0.24em',right:'17em',top:'90.87em'}}/> */}
                       <img src={artistcarouselrlines2} style={{position:'absolute',width:'0.388em',height:'4.88em',right:'2em',bottom:'5em'}}/>
                     
                     
                        <div style={{display:'flex',flexDirection:'row',width:'5%'}}>
             

             
                        </div>
 

                        <div  style={{height:'50.625em',width:dimensions.width-241.25,display:'flex',flexDirection:'column',alignItems:'center',alignSelf:'center',position:'relative'}}>
                        <img src={artistcarouselrlines1} style={{position:'absolute',width:'1.49em',height:'29.96em',right:'0%',top:'14em'}}/>
                            <div className='CarouselHeader'>{t('Whichplanfits')}</div>
                            <div style={{width:dimensions.width-391.25,maxHeight:'40em',overflow:'hidden'}} >
                            <Carousel ref={carouselRef} showArrows={false} showStatus={false} swipeable={false} showThumbs={false} width="100%" 
                             selectedItem={activeIndex}
                            renderIndicator={(onClickHandler, isSelected, index, label)=>{
                              const defStyle = { marginLeft: 20, color: "white", cursor: "pointer" };
                              const deselectedIcon = { width:'5em',height:'1em',marginBottom:'35em',border:'2px #ffffff solid',color:'transparent',cursor:'pointer',marginLeft:20,display: 'inline-block',position:'relative',top:'100%'}
                              const selectedIcon = {width:'5em',height:'1em',marginBottom:'35em',backgroundImage:carouselItem,color:'transparent',cursor:'pointer',marginLeft:20,display: 'inline-block'}
                            
                              // if(activeIndex===0){
                              //   setCarouselItem('#EA4600')
                              // }
                              // if(activeIndex===1){ 
                              //   setCarouselItem('#D88AF3')
                              // }
                              // if(activeIndex===2){
                              //   setCarouselItem('#96FFF9')
                              // }
                              // if(activeIndex===3){
                              //   setCarouselItem('#D4AD7F')
                              // }
                              if(activeIndex===0){
                                setCarouselItem('radial-gradient(circle, rgba(187,82,1,1) 0%, rgba(186,102,2,1) 98%)')
                              }
                              if(activeIndex===1){ 
                                setCarouselItem('radial-gradient(circle, rgba(198,91,232,1) 6%, rgba(83,33,100,1) 62%, rgba(23,9,28,1) 100%)')
                              }
                              if(activeIndex===2){
                                setCarouselItem('radial-gradient(circle, rgba(136,228,224,1) 0%, rgba(60,103,99,1) 80%)')
                              }
                              if(activeIndex===3){
                                setCarouselItem('linear-gradient(88deg, rgba(102,27,205,1) 29%, rgba(14,27,106,1) 57%, rgba(6,98,139,1) 100%)')
                              }
                              // if(index===0){
                              //   setCarouselItem('#EA4600')
                              // }else if(index===1){
                              //   setCarouselItem('#D88AF3')
                              // }else if(index===2){
                              //   setCarouselItem('#96FFF9')
                              // }else if(index===3){
                              //   setCarouselItem('#D4AD7F')
                              // }


                              const style = isSelected
                                ? { ...selectedIcon }
                                : { ...deselectedIcon};
                              // const onHoverHandler = (index) =>{
                              //     console.log(index)
                              // }
                        
                              return (
                                <li
                                  style={style}
                                  onClick={()=>{
                                    onClickHandler();
                                    setActiveIndex(index)
                                  }
                                   
                                  }
                                  // onMouseEnter={console.log(index)}
                                  onKeyDown={onClickHandler}
                                  value={index}
                                  key={index}
                                  role="button"
                                  tabIndex={0}
                                  aria-label={`${label} ${index + 1}`}
                                /> 
                                  
                                
                              
                              );
                              // return (
                              //     <img src={CarouselDeselectedIcon} style={{width:'4em',height:'1em',marginLeft:'0.5em'}}
                              //     onClick={onClickHandler}
                              //     onKeyDown={onClickHandler}
                              //     value={index}
                              //     key={index}
                              //     role="button"
                              //     tabIndex={0}
                              //     title={`${label} ${index + 1}`}
                              //     aria-label={`${label} ${index + 1}`}
                              //     />
                              // );
                            }} >
                               
                                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'.06em',paddingTop:'6em',alignSelf:'center',overflow:'visible'}} >
                               
                                  <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'5%',paddingLeft:'5%',position:'relative',overflow:'visible'}}>
                                  {/* <img src={carouselgridlines} style={{position:'absolute',width:'34.25em',height:'20.34em',left:'-10em',top:'-13em'}}/> */}
                                      <div className='NervousPlanName' style={{width:'100%',alignSelf:'flex-start',marginLeft:'0em',textAlign:'left',color:'#EA4600'}}>{t('nervouscarouselheader')}</div>
                                      <div className='NervousPlanName' style={{width:'100%',alignSelf:'flex-start',marginLeft:'0em',textAlign:'left',color:'#FFFFFF',fontSize:'2.1rem'}}>Free</div>

                                      <div className='CarouselPlanDesc'>
                                      <Trans i18nKey="Turnyourmusicinto" components={{1:<br/>}} >
                                      Turn your music into your<br/> career with us
                                    </Trans></div>
                                      <div style={{display:'flex',flexDirection:'row'}}> 
                                        <div style={{display:'flex',flexDirection:'column'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Streamon35plisplatforms')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Accesstoartistverification')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('alllocaldsps')}</div>
                                            </div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Twotracksannually')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Basiceducation')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Keep80%royalties')}</div>
                                            </div>
                                        </div>
                                      </div>
                                  </div>
                                  <div style={{
                                    // backgroundImage:`url(${carouselimageboundary})`,
                                    width:'27.06em',
                                    height:'29.178em',
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    marginTop:'-1em',
                                    position:'relative',
                                    paddingRight:'5%'
                                  }}>
                                    <img src={carouselimageboundary} style={{width:'21.56em',height:'21.56em',position:'absolute'}}/>
                                    <img src={nervousplangradient} style={{width:'20.56em',height:'20.56em'}}/>
                                  </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'6em',marginRight:'0em'}}>
                                  <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'5%',paddingLeft:'6%',position:'relative'}}>
                                  {/* <img src={carouselgridlines} style={{position:'absolute',width:'34.25em',height:'20.34em',left:'-10em',top:'-13em'}}/> */}
                                      <div className='NervePlusName' style={{width:'90%',alignSelf:'flex-start',marginLeft:'0em',textAlign:'left',color:'#D88AF3'}}>{t('nerveplusheader')}</div>
                                      <span className='NervePlusName' style={{width:'90%',alignSelf:'flex-start',marginLeft:'0em',textAlign:'left',color:'#FFFFFF',fontSize:'2.1rem'}}>$19.99<span style={{fontSize:'1.2rem'}}>/ year</span></span>
                                      <div className='CarouselPlanDesc'>
                                      <Trans i18nKey="Escalateyourmusicjourney" components={{1:<br/>}} >
                                      Escalate your music journey
                                    </Trans></div>
                                      <div style={{display:'flex',flexDirection:'row'}}> 
                                        <div style={{display:'flex',flexDirection:'column'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Keep100%ofyourroyalties')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Releaseon150+DSPs')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Insights&analytics')}</div>
                                            </div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Royaltystatement')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('PresavelinkonmajorDSPs')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Accesstopromotetools')}</div>
                                            </div>
                                        </div>
                                      </div>
                                  </div>
                                  
                                  <div style={{
                                    // backgroundImage:`url(${carouselimageboundary})`,
                                    width:'27.06em',
                                    height:'29.178em',
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    marginTop:'-1em',
                                    paddingRight:'5%'
                                  }}>
                                     <img src={carouselimageboundary} style={{width:'21.56em',height:'21.56em',position:'absolute'}}/>
                                    <img src={nerveplusgradient} style={{width:'20.56em',height:'20.56em'}}/>
                                  </div>
                                
                                </div>

                                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'7em',paddingRight:'3em'}}>
                                  <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'5%',paddingLeft:'10%',position:'relative'}}>
                                  {/* <img src={carouselgridlines} style={{position:'absolute',width:'34.25em',height:'20.34em',left:'-10em',top:'-13em'}}/> */}
                                      <div className='NerveProName' style={{width:'100%',alignSelf:'flex-start',color:'#96FFF9',marginLeft:'0em',textAlign:'left'}}>{t('nerveproheader')}</div>
                                      <span className='NerveProName' style={{width:'100%',alignSelf:'flex-start',color:'#FFFFFF',marginLeft:'0em',textAlign:'left',fontSize:'2.1rem'}}>$49.99 <span style={{fontSize:'1.2rem'}}>/ year</span></span>
                                      <div className='CarouselPlanDesc'>
                                      <Trans i18nKey="Expandyourartistichorizons" components={{1:<br/>}} >
                                      Expand your artistic<br/> horizons.
                                    </Trans></div>
                                      <div style={{display:'flex',flexDirection:'row'}}> 
                                        <div style={{display:'flex',flexDirection:'column'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Includesallplusbenefits')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Promotionaltools')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Eligibilitytosubmityourwork')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Lyricsvideoservice')}</div>
                                            </div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Exclusivepublishingandsyncservice')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('ArtistPageswebsitetobuildyourbrand')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Eligibletobeinvitedtopartner')}</div>
                                            </div>
                                        </div>
                                      </div>
                                  </div>

                                  <div style={{
                                    // backgroundImage:`url(${carouselimageboundary})`,
                                    width:'27.06em',
                                    height:'29.178em',
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    marginTop:'-1em',
                                    paddingRight:'3%'
                                  }}>
                                     <img src={carouselimageboundary} style={{width:'21.56em',height:'21.56em',position:'absolute'}}/>
                                      <img src={nerveprogradient} style={{width:'20.56em',height:'20.56em'}}/>
                                  </div>

                                
                                </div>

                                <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'38.06em',alignSelf:'center',paddingTop:'6em'}}>
                                  <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',paddingRight:'5%',paddingLeft:'8%',position:'relative'}}>
                                  {/* <img src={carouselgridlines} style={{position:'absolute',width:'34.25em',height:'20.34em',left:'-10em',top:'-13em'}}/> */}
                                      <div className='NexdName' style={{width:'100%',alignSelf:'flex-start',marginLeft:'0em',color:'#520C90',textAlign:'left'}}>{t('inviteonlyheader')}</div>
                                      <div className='NexdName' style={{width:'100%',alignSelf:'flex-start',marginLeft:'0em',color:'#FFFFFF',textAlign:'left',fontSize:'2.1rem'}}>Invite only</div>
                                      <div className='CarouselPlanDesc'><Trans i18nKey="Embracetheglobalrhythms" components={{1:<br/>}} >
                                      Embrace the global<br/> rhythms.
                                    </Trans></div>
                                      <div style={{display:'flex',flexDirection:'row'}}> 
                                        <div style={{display:'flex',flexDirection:'column'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Includesallprobenefits')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Customdistributionstrategy')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Scheduledreleasedates')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Dedicatedcustomersupport')}</div>
                                            </div>
                                        </div>

                                        <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Advancedstreaminganalytics')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Playlistpitching')}</div>
                                            </div>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                              <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                              <div className='CarouselPlanItem'>{t('Globalbusinessconsulting')}</div>
                                            </div>
                                        </div>
                                      </div>
                                  </div>
                                  <div style={{
                                    // backgroundImage:`url(${carouselimageboundary})`,
                                    width:'27.06em',
                                    height:'29.178em',
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    marginTop:'-1em',
                                    paddingRight:'5%'
                                  }}>
                                    <img src={carouselimageboundary} style={{width:'21.56em',height:'21.56em',position:'absolute'}}/>
                                    <img src={nexdgradient} style={{width:'20.56em',height:'20.56em'}}/>
                                  </div>

                                  
                                </div>
                            </Carousel>

                       

                            </div>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2.5em',width:'100%',width:dimensions.width-391.25,zIndex:'4',justifyContent:'center'}}>
                                <div style={{height:'1px',width:'74.94%',position:'relative',backgroundColor:'rgba(255,255,255,50%)'}}>
                                  <div className={progress1style} style={{height:'1px',position:'absolute',left:'0em',backgroundColor:'#FF6694',zIndex:'2'}}/>
                                </div>
                                {
                                    activeIndex!==0 &&
                                    <img src={CarouselBackIcon} className="artistCarouselBtn" style={{marginLeft:'1em',marginRight:'0.5em'}} onClick={()=>prevArtist()}/>
                                }
                                {
                                    activeIndex===0 &&
                                    <img src={CarouselBackIcon} style={{  padding: '0.75em',marginLeft:'1em',marginRight:'0.5em',cursor:'default'}}/>
                                }

                                {
                                    activeIndex!==3 &&
                                    <img src={CarouselNextIcon} className="artistCarouselBtn" onClick={()=>nextArtist()} />
                                }
                                {
                                    activeIndex===3 &&
                                    <img src={CarouselNextIcon} style={{  padding: '0.75em',cursor:'default'}}/>
                                  
                                }
                            </div>
                          </div>
                        </div>

                        <div style={{
                                    // backgroundColor:'red',
                                    backgroundColor:'#15171B',
                                    // backgroundImage:`url(${LaunchMusicBanner})`, 
                                    height:'75.18em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'cover',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>
                                    <img src={ArtistDots1} style={{position:'absolute',width:'1.48em',height:'26.83em',top:'8em',left:'1em',zIndex:'1'}}/>
                                  <div style={{width:'65.78%',display:'flex',flexDirection:'column',alignItems:'center',zIndex:'2'}}> 
                                  <div style={{display:'flex',flexDirection:'row',marginLeft:'3em'}}>
                                
                                    <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                                      <div className='StepSlashes' style={{marginLeft:'-1.7em'}}>\\</div>
                                      <span className='StepHeader' style={{marginLeft:'-1.5em'}}>Launch Your Music Journey<br/> in <span style={{color:'#9C4FFF'}}>Four Simple Steps</span></span>
                                    
                                    </div>
                                    {/* <img src={HowItWorksGraphic} style={{width:'19.03em',height:'1.124em',alignSelf:'flex-end',marginLeft:'6.5em'}}/> */}
                                    <div style={{width:'19.03em',height:'1.124em',alignSelf:'flex-end',marginLeft:'30.5em'}} className='Howitworkstxt'>
                                      HOW IT WORKS
                                    </div>
                                  </div>

                                  <div style={{display:'flex',flexDirection:'row',marginTop:'4em',position:'relative'}}>
                                    <img src={EArtistPage} style={{position:'absolute',width:'31.75em',height:'38.47em',top:'-16em',right:'-15em',zIndex:'0'}}/>
                                    <div style={{display:'flex',flexDirection:'column',marginRight:'1.5em'}}>

                                      {
                                        stepOption===0 &&
                                        
                                        <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                                        <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                                        <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                
                                        <div className='SelectedStepTitle'>
                                        <span style={{color:'#FF6694'}}>1.</span> &nbsp; &nbsp;Sign Up and Setup
                                        </div>
                                        <div className='SelectedStepDesc'>
                                        Start by signing up for free. Set up your artist or producer profile to tailor your experience. Our dashboard is designed to give you full control with minimal fuss.
                                        </div>
                                        </div>
                                        </div>
                                      }
                                      {
                                        stepOption!==0 &&
                                        <div className='UnselectedStep' onClick={()=>setStepOption(0)}>
                                        1. &nbsp; &nbsp;Sign Up and Setup
                                        </div>
                                      }
                                      {
                                        stepOption===1 &&
                                        <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                                            <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                                        <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                                      
                                        <div className='SelectedStepTitle'>
                                        <span style={{color:'#FF6694'}}>2.</span> &nbsp; &nbsp;Upload and Distribute
                                        </div>
                                        <div className='SelectedStepDesc'>
                                        Upload your tracks and select the platforms you want to reach. With just one click, your music is queued for distribution to over 150+ streaming services worldwide. Our system handles everything from formatting to compliance checks, ensuring your music is ready to make an impact.
                                        </div>
                                      </div>
                                      </div>
                                      }

                                      {
                                        stepOption!==1 &&
                                        <div className='UnselectedStep' onClick={()=>setStepOption(1)}>
                                        2. &nbsp; &nbsp;Upload and Distribute
                                        </div>
                                      }

                                      {
                                        stepOption===2 &&
                                        <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                                        <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                                        <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>

                                        <div className='SelectedStepTitle'>
                                        <span style={{color:'#FF6694'}}>3.</span> &nbsp; &nbsp;Analyze and Earn
                                        </div>
                                        <div className='SelectedStepDesc'>
                                        Once your music is live, monitor its performance through our real-time analytics dashboard. View streams, downloads, and earnings. Receive actionable insights to optimize your releases and maximize your revenue
                                        </div>
                                      </div>
                                      </div>
                                      }

                                      {
                                        stepOption!==2 &&
                                        <div className='UnselectedStep' onClick={()=>setStepOption(2)}>
                                        3. &nbsp; &nbsp;Analyze and Earn
                                      </div>
                                      }

                                      {
                                        stepOption===3 &&
                                        <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                                        <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                                        <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                                      
                                        <div className='SelectedStepTitle'>
                                        <span style={{color:'#FF6694'}}>4.</span> &nbsp; &nbsp;Promote and Pitch
                                        </div>
                                        <div className='SelectedStepDesc'>
                                        Utilize our suite of promotional tools to boost your presence. Get featured on playlists, use our social media promo kits, or submit your tracks for exclusive placement opportunities in films, commercials, and more.
                                        </div>
                                      </div>
                                      </div>
                                      } 

                                    {
                                        stepOption!==3 &&
                                        <div className='UnselectedStep' onClick={()=>setStepOption(3)}>
                                      4. &nbsp; &nbsp;Promote and Pitch
                                      </div>
                                      }
                                    

                
                                    </div>
                                    {
                                      stepOption ===0 &&
                                      <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/reg7anpd5riyw6p8br2n"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(1)}/>
                                    }
                                    {
                                      stepOption ===1 &&
                                      <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/qd9cbsqkmaurkkbapend"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(2)}/>
                                    }
                                    {
                                      stepOption ===2 &&
                                      <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjbqmausmdsobvrxnvxb"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(3)}/>
                                    }
                                    {
                                      stepOption ===3 &&
                                      <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uu4ogicvwcosyh1gub4e"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(0)}/>
                                    }
                                  
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                    {
                                      stepOption ===0 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption !==0 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption ===1 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption !==1 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption ===2 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption !==2 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption ===3 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                    {
                                      stepOption !==3 &&
                                      <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                                    }
                                      
                                    </div>
                                  </div>

                                  </div>


                                  <div style={{
                                    backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ejxpdmkw3ebskpufwshk")`, 
                                    height:'20.25em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>
                                  <div className='StepsH1'>
                                  Escape Major Constraints <br/>Elevate Your Music with Us Now
                                  </div>

                                  <div className='StepsH2'>
                                    Ready to make your mark in the music world? Sign up now and take the first step towards realizing your<br/> dreams with our easy-to-use, comprehensive music platform.
                                  </div>

                                  <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:'3'}}  onClick={()=>navigate("/Signup")}>
                                      <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                      <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                      <div className="TestMedium">
                                      {t('Getstarted')}
                                      <div className="HoverOverlay" />
                                      </div>
                                  </div>
                      </div>
                          
                      </div>
                    

                      <div style={{
                                    backgroundImage:'linear-gradient(225deg, rgba(21,23,27,1) 43%, rgba(21,23,27,1) 60%, rgba(127,70,132,1) 100%)',
                                    
                                    height:'45.812em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>

                                    <img src={ArtistBanner3Dots1} style={{width:'5.46em',height:'8.785em',position:'absolute',bottom:'4.607em',right:'5.99em'}}/>
                                  
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em',alignItems:'center',justifyContent:'center',marginLeft:'-17em'}}>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dh8mnkyprhwgwwa6uf7e"} style={{width:'44.81em',height:'40.81em'}}/>
                                    <div style={{display:'flex',flexDirection:'column',marginLeft:'-19.5em',marginTop:'-3.5em'}}>
                                          <span className='MonetizeCreativityTxt'><span className='slash'>//</span><span className='CreativityTxt'>Monetize</span> Your Creativity</span>
                                          <div className='ProtectAndProfitTxt'>Protect and profit from your content across digital platforms. Our UGC division ensures your creations work for you—everywhere.</div>

                                          <div className='MonetizeContainer'> 
                                          <img src={ArtistBanner3Dots2} style={{width:'9.907em',height:'0.566em',position:'absolute',bottom:'0em',right:'0em'}}/>
                                          <div style={{display:'flex',flexDirection:'row',position:'absolute',top:'1.5em'}}>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                            <div style={{width:'2.75em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                          </div>
                                          <div className='UnlockTheFullPotential'>
                                          Unlock the full potential of your content with N3RVE's UGC Management services, drawing on the innovative approach of Fuga UGC. Our platform empowers you to claim and control how your music is used across digital platforms, from YouTube to TikTok and beyond. Whether it's user-uploaded videos or major online broadcasts, we ensure that your music is properly recognized and monetized.<br/> <br/> Our advanced technology scans and identifies your music worldwide, securing your rights and boosting your revenue through precise claim management and dispute resolution. Embrace the power of digital media and see your earnings grow as your music reaches new audiences in dynamic ways.
                                          </div>
                                          </div>
                                          <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',marginLeft:'0em'}}>
                                          <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                          <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                          <div className="TestMedium" onClick={()=>navigate("/monetize")}>
                                          LEARN MORE
                                          <div className="HoverOverlay" />
                                          </div>
                                  </div>
                                    </div>
                                    </div>
                                  
                                  
                        </div> 


                        <div style={{
                                    backgroundImage:'linear-gradient(103deg, rgba(21,23,27,1) 43%, rgba(21,23,27,1) 90%, rgba(60,165,179,0.7036939775910365) 100%)',
                                    height:'48.812em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative',
                                    paddingTop:'3em'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>

                                    <img src={ArtistDots6} style={{width:'0.72em',height:'7.52em',position:'absolute',top:'5.47em',left:'1%'}}/>
                                    
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em',alignItems:'center',justifyContent:'center',maxWidth:'50%'}}>
                                    
                                    <div style={{display:'flex',flexDirection:'column',marginRight:'-22em',marginTop:'-2.8em',position:'relative'}}>
                                          <span className='MonetizeCreativityTxt'><span className='slash'>//</span>Professional <span className='CreativityTxt'>Publishing Power</span></span>
                                          <div className='ProtectAndProfitTxt' style={{maxWidth:'30.67em'}}>Step into the spotlight with confidence as you take control of your musical rights. N3RVE Publishing isn’t just about managing your work; it's about empowering your music career with the support and expertise that you deserve.</div>
                                          <div style={{display:'flex',flexDirection:'row',position:'absolute',top:'15.5em'}}>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundColor:'transparent',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                            <div style={{width:'2.55em',height:'0.18em',backgroundColor:'rgba(255,255,255,0.3)',marginRight:'1em'}}/>
                                          </div>
                                          <div className='PotentialContainer' style={{overflow:'visible',position:'relative'}}> 
                                        
                                          <div className='UnlockTheFullPotential' style={{marginTop:'0.3em',position:'relative'}}>
                                          Secure your musical legacy and maximize your earnings with World Collections, powered by industry defining Word Collections. Our comprehensive publishing services ensure that every note you play and every lyric you write is fully protected and monetized. From copyright registration to royalty collection and synchronization licensing, we manage all aspects of your music rights.<br/> <br/> Partner with us to navigate the complexities of music publishing, ensuring that you receive every penny you deserve from performances, streaming, and beyond. Let our expert team guide you through the intricate landscape of global music rights, so you can focus on what you do best—creating unforgettable music.
                                      
                                          </div>
                                          <img src={ArtistBanner3Dots2} style={{width:'9.907em',height:'0.266em',position:'absolute',bottom:'0em',left:'0em'}}/>
                                          </div>
                                          <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
                                          <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                          <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                        
                                          <div className="TestMedium" onClick={()=>navigate("/publishing")}>
                                          LEARN MORE
                                          <div className="HoverOverlay" style={{top:'0em',left:'0em'}}/>
                                          </div>
                                         
                                    </div>
                                  
                                  
                                    </div>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uxpfwovjqauz52j9agq4"} style={{width:'100%',height:'38.43em'}}/>
                                    </div>
                                  
                                  
                        </div> 

                        <div style={{
                                    // backgroundImage:'linear-gradient(90deg, rgba(12,13,26,1) 16%, rgba(158,28,67,1) 94%)',
                                    height:'25.31em',
                                    backgroundColor:'#DFDFDE',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>
                                  <span className='MonetizeCreativityTxt' style={{marginTop:'1.5em',color:'#000000'}}>Expert <span className='CreativityTxt'>Business Management</span></span>
                                  <div className='ProtectAndProfitTxt' style={{textAlign:'center',maxWidth:'100%',color:'#000000'}}>From financial planning to career strategy, our business management services keep your<br/> career on track and your finances in check.</div>
                                  <div style={{width:'5.5em',height:'0.18em',backgroundColor:'#E91353',marginTop:'1.5em'}}/>
                                  <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
                                          <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                          <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                          <div className="TestMedium" onClick={()=>navigate("/monetize")}>
                                          LEARN MORE
                                          <div className="HoverOverlay" />
                                          </div>
                                    </div>
                                  
                          </div>


                          <div style={{
                                    backgroundImage:'linear-gradient(0deg, rgba(62,59,111,1) 0%, rgba(12,13,26,1) 90%)',
                                    height:'45.5em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    backgroundRepeat:'no-repeat',
                                    marginTop: '0em',
                                    padding: '0',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                  }}>
                                  <img src={ArtistBanner3Dots1} style={{width:'5.46em',height:'8.785em',position:'absolute',top:'8.607em',right:'5.99em'}}/>
                                  <img src={ArtistDots7} style={{width:'7.52em',height:'0.75em',position:'absolute',top:'0em',left:'4.73em'}}/>
                                  <span className='MonetizeCreativityTxt' style={{marginTop:'1em'}}>Expand Your Music <span className='CreativityTxt'>Mastery</span></span>

                                  <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}> 
                                      <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'6em'}}>
                                        <div className='ExpandMusicHeader'>Unlock Your Creative Potential</div>
                                        <div style={{display:'flex',flexDirection:'row',marginTop:'0.75em',marginBottom:'0.75em'}}>
                                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                            <div  style={{width:'1.05em',marginLeft:'0.6em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                        </div>
                                        <div className='ExpandMusicDesc'>Dive deeper into the art and business of music with our expertly curated Educational Resources. From mastering production techniques to navigating the complexities of the music industry, our resources are designed to empower you at every step of your journey.</div>
                                      </div>

                                      <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                        <div className='ExpandMusicHeader'>Explore, Learn, Succeed</div>
                                        <div style={{display:'flex',flexDirection:'row',marginTop:'0.75em',marginBottom:'0.75em'}}>
                                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                            <div  style={{width:'1.05em',marginLeft:'0.6em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                        </div>
                                        <div className='ExpandMusicDesc'>Whether you’re polishing your first track or preparing for your next big release, our comprehensive guides, in-depth articles, and interactive webinars provide the insights you need to succeed. Our blog features regular updates from seasoned industry professionals, successful artists, and marketing gurus to keep you at the forefront of music trends and best practices.</div>
                                      </div>
                                  </div>

                                  <div style={{display:'flex',flexDirection:'row',marginTop:'5em'}}> 
                                      <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginRight:'6em'}}>
                                        <div className='ExpandMusicHeader'>Join Our Community of Learners</div>
                                        <div style={{display:'flex',flexDirection:'row',marginTop:'0.75em',marginBottom:'0.75em'}}>
                                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                            <div  style={{width:'1.05em',marginLeft:'0.6em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                        </div>
                                        <div className='ExpandMusicDesc'>Connect with like-minded artists and producers who are as passionate about learning as they are about music. Each article, video, and webinar is an opportunity to learn not only from experts but also from the collective experiences of our vibrant community.</div>
                                      </div>

                                      <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                        <div className='ExpandMusicHeader'>Visit Our Blog</div>
                                        <div style={{display:'flex',flexDirection:'row',marginTop:'0.75em',marginBottom:'0.75em'}}>
                                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                            <div  style={{width:'1.05em',marginLeft:'0.6em',height:'0.125em',backgroundImage:'linear-gradient(4deg, rgba(156,79,255,1) 0%, rgba(130,119,255,0.3983718487394958) 100%)'}}/>
                                        </div>
                                        <div className='ExpandMusicDesc'>Stay current, stay connected, and stay inspired. Click here to explore all our Educational Resources and start transforming your music knowledge today!</div>
                                      </div>
                                  </div>
                          </div>

                    
                    

                      <div style={{backgroundImage:`url(${artistwhychoose})`,width:'100%',display:'flex',alignItems:'center', backgroundSize:'cover',backgroundPosition:'center',position:'relative',overflow:'hidden',paddingBottom:'5em',paddingTop:'5em',backgroundRepeat:'no-repeat'}}>
                           
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',width:'90%'}}>
                                  <div className='WhyChooseUsTxt' style={{color:'white'}}>
                                  {t('Whychooseus')}
                                  </div>

                                  <div style={{display:'flex',flexDirection:'column',marginLeft:'7.5em'}}>

                                      <div className='WhyChooseUsTitle' style={{color:'white'}}>
                                      {t('youown100%')} 
                                      </div>

                                      <div className='WhyChooseUsDesc' style={{color:'white',borderBottom:'2px #FFFFFF solid'}}>
                                      {t('Alwaysownfull')} 
                                      </div>

                                    

                                      <div className='WhyChooseUsTitle' style={{color:'white'}}>
                                      {t('Unlimitedrelease')}
                                      </div>

                                      <div className='WhyChooseUsDesc' style={{color:'white',borderBottom:'2px #FFFFFF solid'}}>
                                      {t('Instantlygetyour')}
                                      </div>

                                      

                                      <div className='WhyChooseUsTitle' style={{color:'white'}}>
                                      {t('Insightstoknow')}
                                      </div>

                                      <div className='WhyChooseUsDesc' style={{color:'white',borderBottom:'2px #FFFFFF solid'}}>
                                      {t('Understandyouraudience')}
                                      </div>

                                      

                                      <div className='WhyChooseUsTitle' style={{color:'white'}}>
                                      {t('Professionalpromo')}
                                      </div>

                                      <div className='WhyChooseUsDesc' style={{color:'white',borderBottom:'2px #FFFFFF solid'}}>
                                      {t('Accessanarray')}
                                      </div>

                                      <div className='WhyChooseUsTitle' style={{color:'white'}}>
                                      {t('Nerveexclusivefeat')}
                                      </div>

                                      <div className='WhyChooseUsDesc' style={{color:'white',borderBottom:'2px #FFFFFF solid'}}>
                                      {t('Connectwithrep')}
                                      </div>

                                    
                                  </div>
                            </div>
                      </div>
                      
                    
                      

                    
                      


{/* {
                        questionaire===1 &&
                        <div className='QuestionaireOpenContainer' style={{ backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o9esrivi2zkjvmom8ph7")`, backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',height:'34.62em'}}>
                          <Questionaire  func={questionaire_result}/>
                        </div>
                      }

                      {
                        questionaire===0 &&
                        <div 
                        id="ComparePlans"
                        style={{ backgroundImage:`url(${QuestionaireClosedBg})`, 
                        height:'25em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <div className='NotSureTxt'>Not sure which plan is the best fit for you?</div>
                          <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'2.75em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                            </div>
                        <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'21.81em',height:'6.43em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}} onClick={()=>setQuestionaire(1)} >
                              <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                              <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                              <div className="TakeQuizBtn">
                                <div style={{marginTop:'0.9em',marginBottom:'1.4em'}}>TAKE A QUIZ</div>
                                <div style={{fontSize:'0.875em',fontWeight:'400'}}>Get recommended plan in 1 minute</div>
                              </div>
                          </div>
                        </div>
                          
                      }


                      {
                        questionaire===2 &&
                        <div className='QuestionaireResultContainer' style={{ backgroundImage:`url(${QuestionareResultBg})`, 
                        height:'49.5em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <N3rvePlan/>
                        </div>
                      } */}

                      <Footer/>
                  </div>
              </Parallax>

                            
              </div>
      
       }








        {/* /*********************************************** */ }

        {/* /** TABLET VIEW */}
        {
             dimensions.width >= 768 && dimensions.width <1024 &&
        <div className="ArtistsContainer">
        <div style={{ 
                      backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cb8xfznxodi10tq26tns")`, 
                      height:'30.515em',
                      // height:'50px',
                      width:'100%',
                      backgroundPosition:'center',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center',
                      backgroundPositionX:'-10em',
                      backgroundSize:'120%',
                      position:'relative'}}>
                {/* <img src={ArtistPgImg1Mob} style={{position:'absolute',width:'100%',height:'30.515em',zIndex:'1'}}/> */}
                <div style={{position:'absolute',width:'100%',height:'30.515em',zIndex:'3',backgroundColor:'rgba(0,0,0,16%)'}}/>
                <div  style={{  
                      width:'100%',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center',
                     }}>
                <div className='ForArtistTxt' style={{marginLeft:'0em',marginTop:'4em',zIndex:'2'}}>
                {t('ForArtist')}
                  </div>

                <div className='FuelYourMusicTxt' style={{marginLeft:'0em',marginTop:'0.5em',textAlign:'center',fontWeight:'500',zIndex:'2'}}>
                  <Trans i18nKey="YouryourmusicTab" components={{1:<br/>}} >
                  Fuel Your Music, <br/> Shape Your Journey
                  </Trans>
                 
                </div>

                <div className='Own100Rights' style={{marginLeft:'0em',marginTop:'0.5em',textAlign:'center',fontWeight:'500',zIndex:'2'}}>
                  {t('Own100%rights')}
                </div>

                <div className='ThisIsWhereTxt' style={{marginLeft:'0em',marginTop:'0.5em',textAlign:'center',fontWeight:'400',width:'50%',zIndex:'2'}}>
                <Trans i18nKey="Thisiswhereyourmusic" components={{1:<br/>}} >
                This is where your music comes alive. Experience a platform<br/> built for artists like you - where resources meet independence,<br/> and creative freedom reigns.<br/>
                  </Trans>
               
                </div>

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.43em',height:'4em', marginTop:'1em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:'4'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="TestMedium">
                        {t('Getstarted')}
                          
                        </div>
                    </div>
                </div>
        </div>

        <div style={{
                      // backgroundColor:'red',
                      backgroundImage:`url(${ArtistPgImg3Tab})`, 
                      height:'58.48em',
                      // height:'50px',
                      width:'100%',
                      backgroundSize:'cover',
                      marginTop: '0em',
                      padding: '0',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center',
                      position:'relative'
                      // lineHeight:'0px',
                      // margin:'0px',
                      // padding:'0px',
                      // flex:'1'
                    }}>

                <img src={Etop} style={{position:'absolute',width:'31.708em',height:'34.44em',top:'15em',right:'10em',zIndex:'1'}}/>
             

                
               
                  
                  <div className='FindADistributionTxt' style={{marginLeft:'0em',marginTop:'0.5em',textAlign:'center',fontWeight:'500',fontSize:'2.5em',width:'11.325em'}}>
                  {t('Findaplanforeach')}
                 
                  </div>

                  <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',marginTop:'2em',width:'100%'}}>

                    <div className='PlanBoxTab'>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'2em',marginRight:'2em'}}>
                            <img className='PlanBoxLogo' src={NervousLogo} alt="Red 4 sided star"/>
                            <div className='PlanBoxName' style={{fontWeight:'500'}}>{t('Nervous')}</div>

                          <div className='PlanBoxPrice'>{t('Free')}</div>
                          </div>
                
                       

                        

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'-0.5em'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Delivertosocial')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Take90%royalty')}</div>
                        </div>
                      </div>

                    </div>


                    <div className='PlanBoxTab' style={{borderTopLeftRadius:'0px',borderTopRightRadius:'0px',position:'relative',marginTop:'2em',justifyContent:'center'}}>
                        {/* <div className='MostPopularTxt' >
                          MOST POPULAR
                        </div> */}
                        <div className="Mostpoptxt" style={{left:'0em'}}>
                        MOST POPULAR
                        </div>

                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'2em',marginRight:'2em'}}>
                        <img className='PlanBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star"/>

                            <div className='PlanBoxName' style={{width:'100%'}}>{t('Nervousplus')}</div>

                            <span className='PlanBoxPrice'> 
                                        <Trans i18nKey="Nervousplusprice">
                                        $19.99
                                        <span className='PlanBoxPriceYrTxt'>/ year</span>
                            </Trans></span>

                        </div>


                       
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'0.5em'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>
                          <Trans i18nKey="Includeallbenefits" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVous
                         </Trans>
                      </div>
                 
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Brandyourself')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
                        </div>
                      </div>
                      
                     
                      
                    </div>

                    <div className='PlanBoxTab' style={{marginTop:'1em',height:'12.5em',justifyContent:'center'}}>
                    <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'1em',marginRight:'4em'}}>
                    <img className='PlanBoxLogo' src={NerveProLogo} alt="Red 4 sided star"/>

                    <div className='PlanBoxName' style={{textAlign:'left',width:'100%'}}>{t('Nervepro')}</div>

                    <span className='PlanBoxPrice'> 
                      <Trans i18nKey="Nerveproprice">
                          $49.99
                      <span className='PlanBoxPriceYrTxt'>/ year</span>
                      </Trans></span>

                      </div>
                        

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'-3.5em'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVE Plus
                         </Trans></div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>Unlimited DSP Release</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Youtubemonetize')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{1:<br/>}} >
                          Exclusive Brand/Sync<br/> Deals
                         </Trans></div>
                        </div>
                      </div>
                      
                    
                    </div>

                    <div className='PlanBoxTab' style={{marginTop:'1em',height:'11em'}}>

                    <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginLeft:'2.5em',marginRight:'1.5em'}}>
                    <img className='PlanBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star"/>

                      <div className='PlanBoxName'>{t('Inviteonly')}</div>

                      <div className='PlanBoxPrice'>By Invitation only</div>


                        </div>
                        
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Includedallbene" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVE Pro
                         </Trans></div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Audienceengage')}</div>
                        </div>
                      </div>
                      
                    </div>

                  </div>

        </div>

        {/* {
                        questionaire===1 &&
                        <div className='QuestionaireOpenContainer' style={{ backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o9esrivi2zkjvmom8ph7")`, backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',height:'34.62em'}}>
                          <Questionaire  func={questionaire_result}/>
                        </div>
                      }

                      {
                        questionaire===0 &&
                        <div 
                        style={{ backgroundImage:`url(${QuestionaireClosedBg})`, 
                        height:'25em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <div className='NotSureTxt' style={{textAlign:'center'}}>Not sure which plan is the<br/> best fit for you?</div>
                          <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em'}}>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'2.75em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                            </div>
                        <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'21.81em',height:'6.43em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}} onClick={()=>setQuestionaire(1)} >
                              <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                              <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                              <div className="TakeQuizBtn">
                                <div style={{marginTop:'0.9em',marginBottom:'1.4em'}}>TAKE A QUIZ</div>
                                <div style={{fontSize:'0.875em',fontWeight:'400'}}>Get recommended plan in 1 minute</div>
                              </div>
                          </div>
                        </div>
                          
                      }


                      {
                        questionaire===2 &&
                        <div className='QuestionaireResultContainer' style={{ backgroundImage:`url(${ArtistPgImg3})`, 
                        height:'54.5em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <N3rvePlan/>
                        </div>
                      } */}



        <div style={{backgroundImage:`url(${artistwhychoose})`,position:'relative',width:'100%',display:'flex',flexDirection:'column',alignItems:'center', backgroundSize:'cover',paddingTop:'5em',paddingBottom:'5em'}}>
             
       

           
                <div style={{display:'flex',flexDirection:'column',paddingLeft:'0.2em'}}>

                <div className='WhyChooseUsTxt' style={{color:'#FFFFFF',marginLeft:'0em',fontSize:'3rem',fontWeight:'500',width:'90%',marginBottom:'0.5em'}}>
                {t('Whychooseus')}
                </div>

                 <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'90%'}}>
                 {t('youown100%')} 
                 </div>

                 <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'100%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                 {t('Alwaysownfull')} 
                 </div>

                

                 <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'90%'}}>
                 {t('Unlimitedrelease')}
                 </div>

                 <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'100%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                 {t('Instantlygetyour')}
                 </div>

                 

                 <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'90%'}}>
                 {t('Insightstoknow')}
                 </div>

                 <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'100%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                 {t('Understandyouraudience')}
                 </div>

                 

                 <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'90%'}}>
                 {t('Professionalpromo')}
                 </div>

                 <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'100%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                 {t('Accessanarray')}
                 </div>

                 

                 <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'90%'}}>
                 {t('Nerveexclusivefeat')}
                 </div>

                 <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'100%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                 {t('Connectwithrep')}
                 </div>
                  </div>
    </div>
        
        <div style={{
          // backgroundImage:`url(${ArtistPgImg6})`,
          height:'35.5em',
          width:'100%',
           backgroundSize:'cover',
           display:'flex',
           flexDirection:'column',
           alignItems:'center',
           position:'relative'}}>
              <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/fbxizmo9xaxqydl2mbu0"} style={{width:'100%',height:'35.5em',position:'absolute',zIndex:'1'}}/>
              <img src={N3rveLogo} style={{width:'5.87em',height:'1.125em',marginTop:'6.375em',marginBottom:'1.5em',zIndex:'2'}}/>
              <div className='WereReadyTxt' style={{zIndex:'2',fontSize:'3rem',fontWeight:'500',maxWidth:'40%',textAlign:'center'}}>
                      <Trans i18nKey="Wearereadyareu" components={{1:<br/>}} >
                          We're Ready. Are You?
                      </Trans>
                    </div>
                    <div className='WeAreSetTxt' style={{zIndex:'2'}}> <Trans i18nKey="Wearesettoamplify" components={{1:<br/>}} >
                    We are set to amplify your music on a global scale. Don't wait to leap-<br/>start today and complete the puzzle to your career success.
                         </Trans> </div>
                    

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'30.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:'2'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="TestLarge">
                        {t('Joinus')}
                        </div>
                    </div>
                   
        </div>
        

      
        <div id="ComparePlanss" style={{width:'100%',backgroundImage:'radial-gradient(37.58% 49.29% at 51.77% 54.66%, #1C2732 0%, #181B20 75.34%) ',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em', backgroundSize:'cover'}}>
                  <div className='CompareAllFeaturesTxt'>{t('Compareallfeature')}</div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'center'}}>
                        <div style={{width:'23%',height:'9.562em',backgroundColor:'rgba(0,0,0,9%)'}}>

                        </div>

                        <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                          <img className='CompareLogo' src={NervousLogo} alt="Red 4 sided star"/>
                          <div className='ComparePlanName'>{t('Nervous')}</div>
                          <div className='ComparePlanPrice'>{t('Free')}</div>
                        </div>

                        <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                          <img className='CompareLogo' src={NervousPlusLogo} alt="Purple 5 sided star"/>
                          <div className='ComparePlanName'>{t('Nervousplus')}</div>
                          <div className='ComparePlanPrice'> <Trans i18nKey="Nervousplusprice">
                                    $19.99
                                    <span className='PlanBoxPriceYrTxt'>/ year</span>
                                    </Trans></div>
                        </div>

                        <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                          <img className='CompareLogo' src={NerveProLogo} alt="Green 8 sided star"/>
                          <div className='ComparePlanName'>{t('Nervepro')}</div>
                          <div className='ComparePlanPrice'> <Trans i18nKey="Nerveproprice">
                                    $49.99
                                    <span className='PlanBoxPriceYrTxt'>/ year</span>
                                    </Trans></div>
                        </div>
                  </div>
                  
                  <div className='TableHeader'>
                  {t('Earnings')}    
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Revenue')}  
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                           80% 
                        </div>
 
                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                           100% 
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                            100% 
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        <Trans i18nKey="Splitearnings" components={{1:<br/>}} >
                        Split earnings among<br/> collaborators.
                         </Trans> 
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                       
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Youtuberevenue')}   
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                       
                  </div>
  

                  <div className='TableHeader'>
                  {t('Distribution')}
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Release')}
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <Trans i18nKey="2tracksperyear" components={{1:<br/>}} >
                                      2 tracks per<br/> year
                                      </Trans>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        {t('Unlimited')}   
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        {t('Unlimited')}   
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Distributetoplat')}    
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        {t('35+plat')}  
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        {t('150+plat')}   
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        {t('150+plat')}   
                        </div>
                  </div>

                  

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                     
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        {t('Uniqueisrc')}    
                        { 
                       disc1 &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-15.8em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Isrcandupc')} 
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'12.5em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc1(true)} onMouseLeave={()=>setDisc1(false)}/>
                        </div>


                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        {t('Timerelease')}   
                        { 
                       disc2 &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.2em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Scheduletheexactdate')} 
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.5em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc2(true)} onMouseLeave={()=>setDisc2(false)}/>
                        </div> 

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                


                  
                  <div className='TableHeader'>
                  {t('Digitaltools')}  
                  </div>

                 <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Revenuereports')}  
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('Analyticsandinsights')}  
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center'}} className='TableRowtxt'>
                        {t('AIpowered')}  
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       Creative tool kit <br/> & AI music assistant
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        Creative tool kit <br/> & AI music assistant
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        <Trans i18nKey="Premiumcreative" components={{1:<br/>}} >
                        Premium Creative<br/> Services
                         </Trans> 
                       { 
                       disc3 &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-12em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Collaboratewithexclusivepart')} 
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc3(true)} onMouseLeave={()=>setDisc3(false)}/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div className='TableHeader'>
                  {t('Marketing')}
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                      <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                      {t('Verifiedartsup')}
                      { 
                       disc4 &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-12em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Getassistancetoattain')} 
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc4(true)} onMouseLeave={()=>setDisc4(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        <Trans i18nKey="Presavelineplace" components={{1:<br/>}} >
                        Presave link <br/> procurement
                         </Trans> 
                       { 
                       disc5 && cookies.get('lang') === 'en' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.5em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Getpresavelinkshassle')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                        </div>
                       }

                      { 
                       disc5 && cookies.get('lang') === 'jp' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Getpresavelinkshassle')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc5(true)} onMouseLeave={()=>setDisc5(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>
                  
                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        <Trans i18nKey="Youtubemarketingaddon" components={{1:<br/>}} >
                        Youtube Marketing <br/> Add-On
                         </Trans>  
                      { 
                       disc6 && cookies.get('lang') === 'en' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.7em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Exclusiveserviceaccess')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'10.9em'}}/>
                        </div>
                       }

                      { 
                       disc6 && cookies.get('lang') === 'jp' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-11.7em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Exclusiveserviceaccess')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.2em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc6(true)} onMouseLeave={()=>setDisc6(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        {t('Brandsync')}
                      { 
                       disc7 && cookies.get('lang') === 'en' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Unlockopportunity')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.3em'}}/>
                        </div>
                       }

                    { 
                       disc7 && cookies.get('lang') === 'jp' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.5em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Unlockopportunity')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc7(true)} onMouseLeave={()=>setDisc7(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        {t('Exclusives')}
                      { 
                       disc8 && cookies.get('lang') === 'en' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.8em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Accessexcusivesyncdeals')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                        </div>
                       }
                        { 
                       disc8 && cookies.get('lang') === 'jp' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.8em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Accessexcusivesyncdeals')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc8(true)} onMouseLeave={()=>setDisc8(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                        {t('Playlistsubmission')}
                      { 
                       disc9 && cookies.get('lang') === 'en' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.6em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Wefacilitateplaylist')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.7em'}}/>
                        </div>
                       }

                    { 
                      disc9 && cookies.get('lang') === 'jp' &&
                        <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'5em'}}>
                          <div className='DisclaimerContainer'>
                          {t('Wefacilitateplaylist')}
                          </div>
                          <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                        </div>
                       }
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc9(true)} onMouseLeave={()=>setDisc9(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',width:'100%',marginBottom:'0.25em',justifyContent:'center'}}>
                        <div style={{width:'18%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between'}} className='TableRowtxt'>
                      Enhanced Marketing
                    
                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc10(true)} onMouseLeave={()=>setDisc10(false)}/>

                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                       
                        </div>

                        <div className='TableRowEntry' style={{width:'18%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                        <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                        </div>
                  </div>

            

               

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'14.93em',height:'4em', marginTop:'3em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="Test" style={{height:'3em',width:'15em'}}>
                          {t('Joinus')}
                        </div>
                    </div>
        </div>


        

        <Footer/>
    </div>
       }






        
        {/* /******************************************************** */ }

        {/* /** MOBILE VIEW */ }
        {
             dimensions.width < 768 &&
        <div className="ArtistsContainer" style={{width:'100%'}}>
        <div style={{ backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/cb8xfznxodi10tq26tns")`, 
                      height:'30.515em',
                      // height:'50px',
                      width:'100%',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center',
                      backgroundSize:'cover',
                      overflowY:'hidden',
                      overflowX:'hidden',
                      position:'relative'}}>

            
                <div className='ForArtistTxtMob' >
                {t('ForArtist')}
                  </div>

                <div className='FuelYourMusicTxt' style={{marginLeft:'0em',marginTop:'0.5em',textAlign:'center',fontWeight:'500',fontSize:'1.75rem',lineHeight:'120.1%'}}>
                  <Trans i18nKey="Youryourmusic" components={{1:<br/>}} >
                  Fuel Your Music, <br/> Shape Your Journey
                  </Trans>
                 
                </div>

                <div className='Own100Rights' style={{marginLeft:'0em',marginTop:'1.5em',textAlign:'center',fontWeight:'600',fontSize:'1rem',lineHeight:'120.1%'}}>
                  {t('Own100%rights')}
                </div>

                <div className='ThisIsWhereTxt' style={{marginLeft:'0em',marginTop:'1em',textAlign:'center',fontWeight:'400',fontSize:'1rem',maxWidth:'85%'}}>
                <Trans i18nKey="Thisiswhereyourmusic" components={{1:<br/>}} >
                This is where your music comes alive. Experience a platform<br/> built for artists like you - where resources meet independence,<br/> and creative freedom reigns.<br/>
                  </Trans>
               
                </div>

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'60%',height:'4em', marginTop:'1em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',zIndex:'3'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="TestMedium" style={{width:'95%'}}>
                        {t('Getstarted')}
                          
                        </div>
                    </div>
                    <img src={ProdcerDots2} style={{width:'5.5em',height:'0.18em',marginTop:'1.5em'}}/>
               <div style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,32%)',position:'absolute',zIndex:'2'}}/>
        </div>

        <div style={{
                      // backgroundColor:'red',
                      backgroundImage:`url(${ArtistPgImg3})`, 
                      height:'110.43em',
                      // height:'50px',
                      width:'100%',
                      backgroundSize:'cover',
                      marginTop: '0em',
                      padding: '0',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center'
                      // lineHeight:'0px',
                      // margin:'0px',
                      // padding:'0px',
                      // flex:'1'
                    }}>

                {/* <img src={Etop} style={{position:'absolute',width:'31.708em',height:'34.44em',top:'26.5em',left:'-8em',zIndex:'1'}}/> */}
                <img src={Ebottom} style={{position:'absolute',width:'31.708em',height:'38.44em',top:'25.48em',right:'15em'}}/>


                {/* <img src={ArtistDots1} style={{position:'absolute',width:'1.48em',height:'26.83em',top:'50.23em',left:'2em'}}/> */}
               
                  
                  <div className='FindADistributionTxt' style={{marginLeft:'0em',marginTop:'2em',marginBottom:'2em',textAlign:'center',fontWeight:'500',fontSize:'1.75em',width:'11.325em'}}>
                  {t('Findaplanforeach')}
                 
                  </div>

                  <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',marginTop:'2em'}}>

                    <div className='PlanBoxMob'>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <img className='PlanBoxLogo' src={NervousLogo} alt="Red 4 sided star"/>
                          </div>
                
                       

                        <div className='PlanBoxName' style={{fontWeight:'500'}}>{t('Nervous')}</div>

                        <div className='PlanBoxPrice'>{t('Free')}</div>

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Delivertosocial')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Take90%royalty')}</div>
                        </div>
                      </div>

                    </div>


                    <div className='PlanBoxMob' style={{borderTopLeftRadius:'0px',borderTopRightRadius:'0px',position:'relative',marginTop:'2em'}}>
                        {/* <div className='MostPopularTxt' >
                          MOST POPULAR
                        </div> */}
                        <div className="Mostpoptxt">
                        MOST POPULAR
                        </div>
                        <img className='PlanBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star"/>

                        <div className='PlanBoxName'>{t('Nervousplus')}</div>

                        <span className='PlanBoxPrice'> 
                                    <Trans i18nKey="Nervousplusprice">
                                    $19.99
                                    <span className='PlanBoxPriceYrTxt'>/ year</span>
                        </Trans></span>

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>
                          <Trans i18nKey="Includeallbenefits" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVous
                         </Trans>
                      </div>
                 
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Brandyourself')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
                        </div>
                      </div>
                      
                     
                      
                    </div>

                    <div className='PlanBoxMob' style={{marginTop:'1em'}}>
                        <img className='PlanBoxLogo' src={NerveProLogo} alt="Red 4 sided star"/>

                        <div className='PlanBoxName'>{t('Nervepro')}</div>

                        <span className='PlanBoxPrice'> 
                                    <Trans i18nKey="Nerveproprice">
                                    $49.99
                                    <span className='PlanBoxPriceYrTxt'>/ year</span>
                                    </Trans></span>

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVE Plus
                         </Trans></div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>Unlimited DSP Release</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Youtubemonetize')}</div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{1:<br/>}} >
                          Exclusive Brand/Sync<br/> Deals
                         </Trans></div>
                        </div>
                      </div>
                      
                    
                    </div>

                    <div className='PlanBoxMob' style={{marginTop:'1em'}}>
                        <img className='PlanBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star"/>

                        <div className='PlanBoxName'>{t('Inviteonly')}</div>

                        <div className='PlanBoxPrice'>By inivitation only</div>

                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',maxWidth:'80%'}}>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'><Trans i18nKey="Includedallbene" components={{1:<br/>}} >
                          Includes all benefits<br/> from N3RVE Pro
                         </Trans></div>
                        </div>

                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginBottom:'0.5em'}}>
                          <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
                          <div className='CheckListItem'>{t('Audienceengage')}</div>
                        </div>
                      </div>
                      
                    </div>

                    {/* <img src={ArtistDots3} style={{width:'0.241em',height:'4.75em',marginTop:'-18.8em',marginLeft:'1em'}}/> */}

                  </div>

                  {/* <img src={ArtistDots2} style={{width:'4.75em',height:'0.24em',marginLeft:'-58.5em',marginTop:'2em'}}/>

                  <img src={ArtistDots4} style={{position:'absolute',width:'0.1em',height:'34.25em',right:'2em',top:'49.74em'}}/> */}

        </div>

        {/* {
                        questionaire===1 &&
                        <div className='QuestionaireOpenContainer' style={{ backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/o9esrivi2zkjvmom8ph7")`, backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',height:'40.62em', width:'100%'}}>
                          <Questionaire  func={questionaire_result}/>
                        </div>
                      }

                      {
                        questionaire===0 &&
                        <div 
                        style={{ 
                        // backgroundImage:`url(${QuestionaireClosedBg})`, 
                        height:'30.5em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        position:'relative',
                        overflow:'hidden',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <div className='NotSureTxt' style={{zIndex:'2',textAlign:'center'}}>Not sure which plan is the best fit for you?</div>
                          <div style={{display:'flex',flexDirection:'row',marginTop:'2.1em',marginBottom:'1em',zIndex:'2'}}>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'0.625em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                                            <div style={{width:'2.75em',height:'0.18em',backgroundImage:'linear-gradient(0deg, rgba(156,79,255,1) 0%, rgba(165,157,255,1) 100%)',marginRight:'1em'}}/>
                            </div>
                        <div style={{border:'0.5px solid rgba(255,255,255,30%)',zIndex:'2',width:'21.81em',height:'6.43em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}} onClick={()=>setQuestionaire(1)} >
                              <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                              <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                              <div className="TakeQuizBtn">
                                <div style={{marginTop:'0.9em',marginBottom:'1.4em'}}>TAKE A QUIZ</div>
                                <div style={{fontSize:'0.875em',fontWeight:'400'}}>Get recommended plan in 1 minute</div>
                              </div>
                          </div>
                          <img src={QuestionaireClosedBg} style={{width:'76.5em',height:'30.5em',position:'absolute',zIndex:'1'}}/>
                        </div>
                          
                      }


                      {
                        questionaire===2 &&
                        <div className='QuestionaireResultContainer' style={{ backgroundImage:`url(${ArtistPgImg3})`, 
                        height:'79.5em',
                        // height:'50px',
                        width:'100%',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        backgroundSize:'cover'}}>
                          <N3rvePlan/>
                        </div>
                      } */}

        {/* <div style={{width:'100%',height:'55.25em',backgroundImage:`url(${ArtistPgImg2})`,display:'flex',flexDirection:'row',alignItems:'center', backgroundSize:'cover',overflow:'visible'}}> */}

            {/* <img src={carouselwhitedots} style={{position:'absolute',width:'0.58em',height:'5.695em',left:'1em',top:'97.75em'}}/>
            <img src={carouselnervelogo} style={{position:'absolute',width:'1.48em',height:'26.838em',left:'2.5em',top:'90.18em'}}/>
            <img src={carouselreddots} style={{position:'absolute',width:'1.82em',height:'3.51em',left:'0em',top:'125.87em'}}/>
            <img src={carouselgreydots} style={{position:'absolute',width:'0.388em',height:'4.88em',right:'1em',top:'120.87em'}}/>
            <img src={carouselredlines} style={{position:'absolute',width:'1.49em',height:'29.96em',right:'5em',top:'95.87em'}}/>
            <img src={carouseltworeddots} style={{position:'absolute',width:'1.12em',height:'0.24em',right:'17em',top:'90.87em'}}/> */}
         

            {/* <img src={carouselgridlines} style={{position:'absolute',width:'34.25em',height:'20.34em',left:'40%',top:'85.95em',marginLeft:'-27em'}}/> */}


            {/* <div style={{height:'59.625em',width:'100%',display:'flex',flexDirection:'column',alignItems:'center'}}> */}
                {/* <div className='CarouselHeader' style={{marginLeft:'0em',fontSize:'1.75em'}}>{t('Whichplanfits')}</div> */}
                {/* <div style={{width:dimensions.width}}>
                <Carousel  showArrows={false} showStatus={false} swipeable={false} showThumbs={false} width="100%" 
                renderIndicator={(onClickHandler, isSelected, index, label)=>{
                  const defStyle = { marginLeft: 20, color: "white", cursor: "pointer" };
                  const deselectedIcon = { width:'20%',height:'1em',marginBottom:'47em',border:'2px #ffffff solid',color:'transparent',cursor:'pointer',marginLeft:'1em',display: 'inline-block',position:'relative',top:'100%'}
                  const selectedIcon = {width:'20%',height:'1em',marginBottom:'47em',backgroundColor:carouselItem,color:'transparent',cursor:'pointer',marginLeft:'1em',display: 'inline-block'}
                 
                  if(index===0){
                    setCarouselItem('#EA4600')
                  }else if(index===1){
                    setCarouselItem('#D88AF3')
                  }else if(index===2){
                    setCarouselItem('#96FFF9')
                  }else if(index===3){
                    setCarouselItem('#D4AD7F')
                  }
          
                  const style = isSelected
                    ? { ...selectedIcon }
                    : { ...deselectedIcon};
                  // const onHoverHandler = (index) =>{
                  //     console.log(index)
                  // }
             
                  return (
                    <li
                      style={style}
                      onClick={
                        onClickHandler
                      }
                      // onMouseEnter={console.log(index)}
                      onKeyDown={onClickHandler}
                      value={index}
                      key={index}
                      role="button"
                      tabIndex={0}
                      aria-label={`${label} ${index + 1}`}
                    /> 
                      
                     
                  
                  );
                  return (
                      <img src={CarouselDeselectedIcon} style={{width:'4em',height:'1em',marginLeft:'0.5em'}}
                      onClick={onClickHandler}
                      onKeyDown={onClickHandler}
                      value={index}
                      key={index}
                      role="button"
                      tabIndex={0}
                      title={`${label} ${index + 1}`}
                      aria-label={`${label} ${index + 1}`}
                      />
                  );
                }} > */}
                    
                    {/* <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',height:'49.06em',paddingTop:'8em',alignSelf:'center'}} >
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',paddingRight:'3.125em',paddingLeft:'10em'}}>
                          <div className='CarouselPlanName' style={{color:'#EA4600'}}>{t('nervouscarouselheader')}</div>
                          
                          <div className='CarouselPlanDesc'>
                          <Trans i18nKey="Turnyourmusicinto" components={{1:<br/>}} >
                          Turn your music into your<br/> career with us
                         </Trans></div>
                         
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Streamon35plisplatforms')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Accesstoartistverification')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('alllocaldsps')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Twotracksannually')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Basiceducation')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em',marginBottom:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Keep80%royalties')}</div>
                                </div>
                            </div>

                           

                            <img src={NervousCarouselImg} style={{width:'17.12em',height:'17.12em',marginLeft:'2em'}}/>
                      </div>
                    
                      
                      
                    </div> */}

                    {/* <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',height:'49.06em',paddingTop:'3em',alignSelf:'center'}}>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',paddingRight:'3.125em',paddingLeft:'8em'}}>
                          <div className='CarouselPlanName' style={{color:'#D88AF3',textAlign:'left',width:'100%'}}>{t('nerveplusheader')}</div>
                          <div className='CarouselPlanDesc'>
                          <Trans i18nKey="Escalateyourmusicjourney" components={{1:<br/>}} >
                          Escalate your music journey
                         </Trans></div>
                         
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Keep100%ofyourroyalties')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Releaseon150+DSPs')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Insights&analytics')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Royaltystatement')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('PresavelinkonmajorDSPs')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em',marginBottom:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Accesstopromotetools')}</div>
                                </div>
                            </div>

                            <img src={NervePlusCarouselImg} style={{width:'17.12em',height:'17.12em',marginLeft:'0em'}}/>
                      </div>
                      
                    
                    </div> */}

                    {/* <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'49.06em',paddingTop:'6em',alignSelf:'center'}}>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',paddingRight:'3.125em',paddingLeft:'8em'}}>
                          <div className='CarouselPlanName' style={{color:'#96FFF9',textAlign:'left',width:'100%'}}>{t('nerveproheader')}</div>
                          <div className='CarouselPlanDesc'>
                          <Trans i18nKey="Expandyourartistichorizons" components={{1:<br/>}} >
                          Expand your artistic<br/> horizons.
                         </Trans></div>
                         
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Includesallplusbenefits')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Promotionaltools')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Eligibilitytosubmityourwork')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Lyricsvideoservice')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Exclusivepublishingandsyncservice')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('ArtistPageswebsitetobuildyourbrand')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em',marginBottom:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Eligibletobeinvitedtopartner')}</div>
                                </div>
                            </div>

                            <img src={NerveProCarouselImg} style={{width:'17.12em',height:'17.12em',marginLeft:'0em'}}/>
                        
                      </div>

                     
                          
          
                    </div> */}

                    {/* <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',height:'49.06em',paddingTop:'4em',alignSelf:'center'}}>
                      <div style={{display:'flex',flexDirection:'column',justifyContent:'center',paddingRight:'3.125em',paddingLeft:'8em'}}>
                          <div className='CarouselPlanName' style={{color:'#D4AD7F',textAlign:'left',width:'100%'}}>{t('inviteonlyheader')}</div>
                          <div className='CarouselPlanDesc'><Trans i18nKey="Embracetheglobalrhythms" components={{1:<br/>}} >
                          Embrace the global<br/> rhythms.
                         </Trans></div>
                        
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Includesallprobenefits')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Customdistributionstrategy')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Scheduledreleasedates')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Dedicatedcustomersupport')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Advancedstreaminganalytics')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Playlistpitching')}</div>
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em',marginBottom:'1em'}}>
                                  <img src={CheckCircle} style={{width:'1.25em',height:'1.25em',marginRight:'0.625em'}}/>
                                  <div className='CarouselPlanItem'>{t('Globalbusinessconsulting')}</div>
                                </div>
                            </div>
                         
                            <img src={InviteOnlyImg} style={{width:'17.12em',height:'17.12em',marginLeft:'0em'}}/>
                      </div>
                     
                    </div> */}
                {/* </Carousel>
                </div> */}
              {/* </div> */}
        {/* </div> */}

       

        <div style={{backgroundImage:`url(${artistwhychoose})`,position:'relative',width:'100%',display:'flex',flexDirection:'column',alignItems:'center', backgroundSize:'cover',paddingTop:'5em',paddingBottom:'5em'}}>
             

       


                  
                    <div style={{display:'flex',flexDirection:'column',paddingLeft:'0.5em'}}>

                    <div className='WhyChooseUsTxt' style={{marginLeft:'0em',fontSize:'3rem',fontWeight:'500',width:'85%',marginBottom:'1.2em',color:'#FFFFFF'}}>
                    {t('Whychooseus')}
                    </div>

                        <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'85%'}}>
                        {t('youown100%')} 
                        </div>

                        <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'98%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                        {t('Alwaysownfull')} 
                        </div>

                       

                        <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'85%'}}>
                        {t('Unlimitedrelease')}
                        </div>

                        <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'98%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                        {t('Instantlygetyour')}
                        </div>

                        

                        <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'85%'}}>
                        {t('Insightstoknow')}
                        </div>

                        <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'98%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                        {t('Understandyouraudience')}
                        </div>

                        

                        <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'85%'}}>
                        {t('Professionalpromo')}
                        </div>

                        <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'98%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                        {t('Accessanarray')}
                        </div>

                        

                        <div className='WhyChooseUsTitle' style={{color:'#FFFFFF',marginLeft:'0em',width:'85%'}}>
                        {t('Nerveexclusivefeat')}
                        </div>

                        <div className='WhyChooseUsDesc' style={{color:'#FFFFFF',marginLeft:'0em',width:'98%',borderBottom:'2px rgba(255,255,255,40%) solid'}}>
                        {t('Connectwithrep')}
                        </div>
                      </div>
        </div>
        
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/r2iuimjngzo2ebescp05")`,height:'41.5em',width:'100%', backgroundSize:'cover',display:'flex',flexDirection:'column',alignItems:'center'}}>
            
              <img src={N3rveLogo} style={{width:'5.87em',height:'1.125em',marginTop:'6.43em'}}/>
              <div className='WereReadyTxt' style={{fontSize:'1.75em',fontWeight:'500',textAlign:'center',width:'50%',lineHeight:'120.1%',marginTop:'1.5em'}}>
                      <Trans i18nKey="Wearereadyareu" components={{1:<br/>}} >
                          We're Ready. Are You?
                      </Trans>
                    </div>
                    <div className='WeAreSetTxt' style={{fontSize:'1em',fontWeight:'400',textAlign:'left',lineHeight:'175%',marginTop:'1.5em',width:'80%'}}> 
                    <Trans i18nKey="Wearesettoamplifymob" components={{1:<br/>}} >
                    We are set to amplify your music on a global scale. Don't wait to leap-<br/>start today and complete the puzzle to your career success.
                         </Trans> </div>
                    

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'90%',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="TestLarge" style={{width:'95%'}}>
                        {t('Joinus')}
                        </div>
                    </div>
                  
        </div>
        

      
        <div id="ComparePlans" style={{width:'100%',overflowY:'hidden',backgroundImage:'radial-gradient(37.58% 49.29% at 51.77% 54.66%, #1C2732 0%, #181B20 75.34%) ',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em', backgroundSize:'cover',overflow:'scroll'}}>
                  <div className='CompareAllFeaturesTxt' style={{fontSize:'1.75em',fontWeight:'500',textAlign:'center',width:'80%',lineHeight:'120.1%',marginTop:'1.5em'}}>{t('Compareallfeature')}</div>

                  <div style={{backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',width:'90%',borderRadius:'4px',display:'flex',flexDirection:'column',alignItems:'center',paddingTop:'1.5em',paddingBottom:'1.5em',paddingBottom:'2em'}}>
                              <img src={NervousLogo} style={{width:'1.27em',height:'1.27em'}}/>
                              <div className='PlanNameMobile'>N3RVous</div>
                              <div className='PlanPriceMobile'>Free</div>

                            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'70%'}}>
                              <div className='PlanInfoHeaderMobile'>
                                EARNINGS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nervoustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>80% Revenue</div>
                              </div>

                              <div className='PlanInfoHeaderMobile'>
                              DISTRIBUTIONS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nervoustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Release 2 tracks per year</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nervoustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Distribute to 35+ platforms</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nervoustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Unique ISRC & UPC</div>
                              </div>

                              <div className='PlanInfoHeaderMobile'>
                              DIGITAL TOOLS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nervoustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Revenue reports</div>
                              </div>

                            </div>
                  </div>

                  <div style={{backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',width:'90%',borderRadius:'4px',display:'flex',flexDirection:'column',alignItems:'center',paddingTop:'1.5em',paddingBottom:'1.5em',marginTop:'1.5em',paddingBottom:'2em'}}>
                              <img src={NervousPlusLogo} style={{width:'1.27em',height:'1.27em'}}/>
                              <div className='PlanNameMobile'>N3RVE Plus</div>
                              <div className='PlanPriceMobile'>$19.99 / year</div>

                            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'70%'}}>
                              <div className='PlanDisclaimerMobile'>
                              in addition to the N3RVE Free, you’ll receive these additional benefits.
                              </div>
                              <div className='PlanInfoHeaderMobile'>
                                EARNINGS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>100% Revenue</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Split earnings among collaborators.</div>
                              </div>

                              <div className='PlanInfoHeaderMobile'>
                              DISTRIBUTIONS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Unlimited Release</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>︎Distribute to 150+ platforms</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Time release</div>
                              </div>

                              <div className='PlanInfoHeaderMobile'>
                              MARKETING & PROMOTION
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Youtube Marketing Add-On</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Presave link procurement</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>“Verified Artist” support</div>
                              </div>

                              <div className='PlanInfoHeaderMobile'>
                              DIGITAL TOOLS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Revenue reports</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Analytics & insights</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>AI-powered Artist Suite</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveplustick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Premium Creative Services</div>
                              </div>

                            </div>
                  </div>
  
                  <div style={{backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',width:'90%',borderRadius:'4px',display:'flex',flexDirection:'column',alignItems:'center',paddingTop:'1.5em',paddingBottom:'1.5em',marginTop:'1.5em',paddingBottom:'2em'}}>
                              <img src={NerveProLogo} style={{width:'1.27em',height:'1.27em'}}/>
                              <div className='PlanNameMobile'>N3RVE Pro</div>
                              <div className='PlanPriceMobile'>$49.99 / year</div>

                            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'70%'}}>
                              <div className='PlanDisclaimerMobile'>
                              in addition to the N3RVE Plus, you’ll receive these additional benefits.
                              </div>
                              <div className='PlanInfoHeaderMobile'>
                                EARNINGS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveprotick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>︎Youtube Revenue Boost</div>
                              </div>
                             

                              <div className='PlanInfoHeaderMobile'>
                              DISTRIBUTIONS
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveprotick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Everything in Plus plan</div>
                              </div>
                             
                              <div className='PlanInfoHeaderMobile'>
                              MARKETING & PROMOTION
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveprotick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Brand & sync rights</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveprotick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Exclusives</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.8em'}}>
                                  <img src={Nerveprotick} style={{width:'0.9em',height:'1.1em'}}/>
                                  <div className='PlanInfoMobile'>Playlist Submission</div>
                              </div>

                             

                            </div>
                  </div>
  

                

                 

                  

                 

                 


                 

                
                  
                  

                  

                  
                   

                   
            

               

                <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'14.93em',height:'4em', marginTop:'3em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                        <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                        <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                        <div className="Test" style={{height:'3em',width:'15em'}}>
                          {t('Joinus')}
                        </div>
                    </div>
        </div>


        

        <Footer/>
    </div>
       }

<ReactModal
          isOpen={plansPopup}
          overlayClassName="Overlay"
          contentLabel="Example Modal"
          onRequestClose={closeModal} // closes the modal when the user presses the escape key
          shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
          style={{
            content:{
              maxWidth:'51.625em',
              width:'80%',
              margin:'auto',
              backgroundImage:'radial-gradient(circle, rgba(28,39,50,1) 0%, rgba(24,27,32,1) 75%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              overflowY: 'scroll',
              borderRadius:'16px',
              border:'0.5px solid transparent',
              scrollbarWidth:'none',
              msOverflowStyle:'none',
              zIndex:'200',
              marginTop:'2em'
            }
          }}
        >
          <div className='CompareFeaturesHeader'>
          {t('Compareallfeature')}
          </div>
          <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'sticky',right:'0em',top:'1.5em',marginTop:'-1.5em',cursor:'pointer',alignSelf:'flex-end',zIndex:'4'}} onClick={()=>setPlansPopup(false)}/>

          <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'center',marginTop:'2.5em',position:'sticky',top:'0',zIndex:'2',backgroundImage:'radial-gradient(circle, rgba(28,39,50,1) 0%, rgba(24,27,32,1) 75%)'}}>
            
            <div style={{display:'flex',flexDirection:'row',backgroundImage:`url(${AA})`,backgroundRepeat:'no-repeat',backgroundSize:'cover',width:'90.07%',alignSelf:'center',alignSelf:'center'}}>
            <div style={{width:'43%',height:'9.562em',backgroundImage:`url(${AA})`,backgroundColor:'#1B1B22',backgroundRepeat:'no-repeat',backgroundSize:'600%'}}/>

           

            <div style={{width:'19%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)'}}>
            <img className='CompareLogo' src={NervousLogo} alt="Red 4 sided star"/>
            <div className='ComparePlanNameM'>{t('Nervous')}</div>
            <div className='ComparePlanPriceM'>{t('Free')}</div>
            </div>

            <div style={{width:'19%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:`url(${AA})`,backgroundColor:'#1B1B22',backgroundRepeat:'no-repeat',backgroundSize:'600%'}}>
            <img className='CompareLogo' src={NervousPlusLogo} alt="Purple 5 sided star"/>
            <div className='ComparePlanNameM'>{t('Nervousplus')}</div>
            <div className='ComparePlanPriceM'> <Trans i18nKey="Nervousplusprice">
                        $19.99 / year
                        </Trans></div>
            </div>

            <div style={{width:'18.94%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(144deg, rgba(204,204,255,0.08) 0%, rgba(204,204,255,0.04) 100%)'}}>
            <img className='CompareLogo' src={NerveProLogo} alt="Green 8 sided star"/>
            <div className='ComparePlanNameM'>{t('Nervepro')}</div>
            <div className='ComparePlanPriceM'> <Trans i18nKey="Nerveproprice">
                        $49.99 / year
                        </Trans></div>
            </div>
        
            </div>                  
            </div>

            <div style={{display:'flex',flexDirection:'column'}}>
            <div className='TableHeaderM' style={{width:'90.07%',alignSelf:'center'}}>
                                {t('Distribution')}
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxtM'>
                                      {t('Release')}
                                      </div>

                                      <div className='TableRowEntryM' style={{width:'17.11%',paddingLeft:'0.9em',paddingRight:'0.5em',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <Trans i18nKey="2tracksperyear" components={{1:<br/>}} >
                                      2 tracks per<br/> year
                                      </Trans>
                                      </div>

                                      <div className='TableRowEntryM' style={{width:'17.11%',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      {t('Unlimited')}   
                                      </div>

                                      <div className='TableRowEntryM' style={{width:'17.11%',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('Unlimited')}   
                                      </div>
                                </div>
                                
                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Distributetoplat')}    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'16.25%',paddingLeft:'0.2em',paddingRight:'0.2em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('35+plat')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'16.25%',paddingLeft:'0.2em',paddingRight:'0.2em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      {t('150+plat')}   
                                      </div>

                                      <div className='TableRowEntry' style={{width:'16.25%',paddingLeft:'0.2em',paddingRight:'0.2em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('150+plat')}   
                                      </div>
                                </div>

                                

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                  
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Uniqueisrc')}    
                                     

                                      <div style={{position:'relative'}}>
                                            { 
                                            disc1 &&
                                            <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                                <div className='DisclaimerContainer'>
                                                {t('Isrcandupc')} 
                                                </div>
                                                <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'12.5em'}}/>
                                            </div>
                                            }
                                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc1(true)} onMouseLeave={()=>setDisc1(false)}/>
                                      </div>
                                      </div>


                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Timerelease')}   
                                      
                                     <div style={{position:'relative'}}>
                                     { 
                                        disc2 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Scheduletheexactdate')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.5em'}}/>
                                        </div>
                                        }
                                        <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc2(true)} onMouseLeave={()=>setDisc2(false)}/>
                                      </div> 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>
            </div>
                                <div className='TableHeaderM' style={{width:'90.07%',alignSelf:'center'}}>
                                {t('Earnings')}    
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Revenue')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                        80% 
                                      </div>
              
                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                        100% 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                          100% 
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Splitearnings" components={{1:<br/>}} >
                                      Split earnings among<br/> collaborators.
                                      </Trans> 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                    
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Youtuberevenue')}   
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                    
                                </div>


                                
                                <div className='TableHeaderM' style={{width:'90.07%',alignSelf:'center'}}>
                                {t('Digitaltools')}  
                                </div>

                              <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Revenuereports')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Analyticsandinsights')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('AIpowered')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    Creative tool kit <br/> & AI music assistant
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      Creative tool kit <br/> & AI music assistant
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Premiumcreative" components={{1:<br/>}} >
                                      Premium Creative<br/> Services
                                      </Trans> 
                                   
                                     <div style={{position:'relative'}}>
                                     { 
                                    disc3 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Collaboratewithexclusivepart')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc3(true)} onMouseLeave={()=>setDisc3(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div className='TableHeaderM' style={{width:'90.07%',alignSelf:'center'}}>
                                {t('Marketing')}
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                    <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                    {t('Verifiedartsup')}
                                   
                                     <div style={{position:'relative'}}>
                                     { 
                                    disc4 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getassistancetoattain')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc4(true)} onMouseLeave={()=>setDisc4(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Presavelineplace" components={{1:<br/>}} >
                                      Presave link <br/> procurement
                                      </Trans> 
                                   
                                    <div style={{position:'relative'}}>
                                    { 
                                    disc5 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getpresavelinkshassle')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                                      </div>
                                    }

                                    { 
                                    disc5 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getpresavelinkshassle')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc5(true)} onMouseLeave={()=>setDisc5(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>
                                
                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Youtubemarketingaddon" components={{1:<br/>}} >
                                      Youtube Marketing <br/> Add-On
                                      </Trans>  
                                   
                                    <div style={{position:'relative'}}>
                                    { 
                                    disc6 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Exclusiveserviceaccess')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'10.9em'}}/>
                                      </div>
                                    }

                                    { 
                                    disc6 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-6.9em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Exclusiveserviceaccess')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.2em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc6(true)} onMouseLeave={()=>setDisc6(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Brandsync')}
                                    
                                    <div style={{position:'relative'}}>
                                    { 
                                    disc7 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Unlockopportunity')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.3em'}}/>
                                      </div>
                                    }

                                  { 
                                    disc7 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Unlockopportunity')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc7(true)} onMouseLeave={()=>setDisc7(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Exclusives')}
                                  
                                    <div style={{position:'relative'}}>
                                    { 
                                    disc8 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Accessexcusivesyncdeals')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                                      </div>
                                    }
                                      { 
                                    disc8 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Accessexcusivesyncdeals')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc8(true)} onMouseLeave={()=>setDisc8(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Playlistsubmission')}
                                    
                                     <div style={{position:'relative'}}>
                                     { 
                                    disc9 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Wefacilitateplaylist')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.7em'}}/>
                                      </div>
                                    }

                                  { 
                                    disc9 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',bottom:'2.5em',marginLeft:'-5.1em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Wefacilitateplaylist')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc9(true)} onMouseLeave={()=>setDisc9(false)}/>
                                      </div>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'38.74%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                    Enhanced Marketing
                                
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc10(true)} onMouseLeave={()=>setDisc10(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'17.11%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ComparePlanCheck} alt="Checkmark"/>
                                      </div>
                                </div>

        
        </ReactModal>
    </div>
   
  );
}

export default Artists;


{/* <div id="ComparePlans" ref={comparePlansRef} style={{width:'100%',backgroundImage:'radial-gradient(37.58% 49.29% at 51.77% 54.66%, #1C2732 0%, #181B20 75.34%) ',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:'5em', backgroundSize:'cover'}}>
                                <div className='CompareAllFeaturesTxt'>{t('Compareallfeature')}</div>

                                <div  style={{display:'flex',flexDirection:'column',padding:'2em'}}>
                                <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',height:'9.562em',backgroundColor:'rgba(0,0,0,9%)'}}>

                                      </div>

                                      <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                        <img className='CompareLogo' src={NervousLogo} alt="Red 4 sided star"/>
                                        <div className='ComparePlanName'>{t('Nervous')}</div>
                                        <div className='ComparePlanPrice'>{t('Free')}</div>
                                      </div>

                                      <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                        <img className='CompareLogo' src={NervousPlusLogo} alt="Purple 5 sided star"/>
                                        <div className='ComparePlanName'>{t('Nervousplus')}</div>
                                        <div className='ComparePlanPrice'> <Trans i18nKey="Nervousplusprice">
                                                  $19.99
                                                  <span className='PlanBoxPriceYrTxt'>/ year</span>
                                                  </Trans></div>
                                      </div>

                                      <div style={{width:'23%',height:'9.562em',display:'flex',flexDirection:'column',alignItems:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                        <img className='CompareLogo' src={NerveProLogo} alt="Green 8 sided star"/>
                                        <div className='ComparePlanName'>{t('Nervepro')}</div>
                                        <div className='ComparePlanPrice'> <Trans i18nKey="Nerveproprice">
                                                  $49.99
                                                  <span className='PlanBoxPriceYrTxt'>/ year</span>
                                                  </Trans></div>
                                      </div>
                                </div>

                

                                <div className='TableHeader' style={{width:'92%',alignSelf:'center'}}>
                                {t('Distribution')}
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Release')}
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('2tracksperyear')} 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      {t('Unlimited')}   
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',display:'flex',flexDirection:'column',paddingLeft:'0em',paddingRight:'0em',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('Unlimited')}   
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Distributetoplat')}    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textIndent:'1.14em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('35+plat')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textIndent:'1.14em',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      {t('150+plat')}   
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textIndent:'1.14em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      {t('150+plat')}   
                                      </div>
                                </div>

                                

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                  
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Uniqueisrc')}    
                                      { 
                                    disc1 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-15.8em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Isrcandupc')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'12.5em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc1(true)} onMouseLeave={()=>setDisc1(false)}/>
                                      </div>


                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Timerelease')}   
                                      { 
                                    disc2 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.2em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Scheduletheexactdate')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.5em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc2(true)} onMouseLeave={()=>setDisc2(false)}/>
                                      </div> 

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div className='TableHeader' style={{width:'92%',alignSelf:'center'}}>
                                {t('Earnings')}    
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Revenue')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                        80% 
                                      </div>
              
                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                        100% 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                          100% 
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Splitearnings" components={{1:<br/>}} >
                                      Split earnings among<br/> collaborators.
                                      </Trans> 
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                    
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Youtuberevenue')}   
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                    
                                </div>


                                
                                <div className='TableHeader' style={{width:'92%',alignSelf:'center'}}>
                                {t('Digitaltools')}  
                                </div>

                              <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Revenuereports')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Analyticsandinsights')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('AIpowered')}  
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    Creative tool kit <br/> & AI music assistant
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      Creative tool kit <br/> & AI music assistant
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Premiumcreative" components={{1:<br/>}} >
                                      Premium Creative<br/> Services
                                      </Trans> 
                                    { 
                                    disc3 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-12em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Collaboratewithexclusivepart')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc3(true)} onMouseLeave={()=>setDisc3(false)}/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div className='TableHeader' style={{width:'92%',alignSelf:'center'}}>
                                {t('Marketing')}
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                    <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                    {t('Verifiedartsup')}
                                    { 
                                    disc4 &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-12em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getassistancetoattain')} 
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.1em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc4(true)} onMouseLeave={()=>setDisc4(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Presavelineplace" components={{1:<br/>}} >
                                      Presave link <br/> procurement
                                      </Trans> 
                                    { 
                                    disc5 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.5em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getpresavelinkshassle')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                                      </div>
                                    }

                                    { 
                                    disc5 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Getpresavelinkshassle')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc5(true)} onMouseLeave={()=>setDisc5(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>
                                
                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'2em',paddingRight:'0em',MozBoxSizing:'border-box',WebkitBoxSizing:'border-box',boxSizing:'border-box'}} className='TableRowtxt'>
                                      <Trans i18nKey="Youtubemarketingaddon" components={{1:<br/>}} >
                                      Youtube Marketing <br/> Add-On
                                      </Trans>  
                                    { 
                                    disc6 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.7em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Exclusiveserviceaccess')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'10.9em'}}/>
                                      </div>
                                    }

                                    { 
                                    disc6 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-11.7em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Exclusiveserviceaccess')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'9.2em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc6(true)} onMouseLeave={()=>setDisc6(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Brandsync')}
                                    { 
                                    disc7 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Unlockopportunity')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.3em'}}/>
                                      </div>
                                    }

                                  { 
                                    disc7 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.5em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Unlockopportunity')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.6em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc7(true)} onMouseLeave={()=>setDisc7(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Exclusives')}
                                    { 
                                    disc8 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.8em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Accessexcusivesyncdeals')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                                      </div>
                                    }
                                      { 
                                    disc8 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-13.8em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Accessexcusivesyncdeals')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'11em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc8(true)} onMouseLeave={()=>setDisc8(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                      {t('Playlistsubmission')}
                                    { 
                                    disc9 && cookies.get('lang') === 'en' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-8.6em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Wefacilitateplaylist')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'5.7em'}}/>
                                      </div>
                                    }

                                  { 
                                    disc9 && cookies.get('lang') === 'jp' &&
                                      <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'5em'}}>
                                        <div className='DisclaimerContainer'>
                                        {t('Wefacilitateplaylist')}
                                        </div>
                                        <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'6.9em',top:'7.4em'}}/>
                                      </div>
                                    }
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc9(true)} onMouseLeave={()=>setDisc9(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',marginBottom:'0.25em',width:'100%',justifyContent:'center'}}>
                                      <div style={{width:'23%',backgroundColor:'rgba(0,0,0,9%)',display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'0em',paddingRight:'0em',textIndent:'1.71em'}} className='TableRowtxt'>
                                    Enhanced Marketing
                                
                                      <img src={DisclaimerIcon} style={{width:'1.5em',height:'1.5em',marginRight:'1.78em'}} onMouseOver={()=>setDisc10(true)} onMouseLeave={()=>setDisc10(false)}/>

                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(255,255,255,1%)'}}>
                                    
                                      </div>

                                      <div className='TableRowEntry' style={{width:'23%',paddingLeft:'0em',paddingRight:'0em',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                                      <img className='CompareCheck' src={ArtistDetailsCheckbox} alt="Checkmark"/>
                                      </div>
                                </div>

                              </div>
                          

                              <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'14.93em',height:'4em', marginTop:'3em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',alignSelf:'center'}}  onClick={()=>navigate("/Signup")}>
                                      <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                      <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                      <div className="Test" style={{height:'3em',width:'15em'}}>
                                        {t('Joinus')}
                                      </div>
                                  </div>
                      </div> */}

                      {/* <div style={{backgroundImage:`url(${ArtistPgImg6})`,height:'41.5em',width:'100%', backgroundSize:'cover',display:'flex',flexDirection:'column',alignItems:'center'}}>
                            <div style={{width:'70%',display:'flex',flexDirection:'column',alignItems:'flex-start',marginTop:'9em'}}>
                            <img src={N3rveLogo} style={{width:'5.87em',height:'1.125em',marginTop:'4.18em'}}/>
                            <div className='WereReadyTxt'>
                                    <Trans i18nKey="Wearereadyareu" components={{1:<br/>}} >
                                        We're Ready. Are You?
                                    </Trans>
                                  </div>
                                  <div className='WeAreSetTxt'> <Trans i18nKey="Wearesettoamplify" components={{1:<br/>}} >
                                  We are set to amplify your music on a global scale. Don't wait to leap-<br/>start today and complete the puzzle to your career success.
                                      </Trans> </div>
                                  

                              <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'30.93em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}  onClick={()=>navigate("/Signup")}>
                                      <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
                                      <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
                                      <div className="TestLarge">
                                      {t('Joinus')}
                                      <div className="HoverOverlay" />
                                      </div>
                                  </div>
                                  </div>
                      </div> */}


{/** Compare plans  */}
{/* <div id="ComparePlans" style={{
  backgroundColor:'#15171B',
  // backgroundColor:'red',
  // backgroundImage:`url(${ArtistBanner})`, 
  height:'56.75em',
  // height:'50px',
  width:'100%',
  backgroundSize:'100%',
  backgroundRepeat:'no-repeat',
  marginTop: '0em',
  padding: '0',
  display:'flex',
  flexDirection:'column',
  alignItems:'center',
  position:'relative'
  // lineHeight:'0px',
  // margin:'0px',
  // padding:'0px',
  // flex:'1'
}}>

<img src={Etop} style={{position:'absolute',width:'38.708em',height:'35.44em',top:'-10em',left:'0em',zIndex:'1'}}/>
<div className='FindADistributionTxt'>
{t('Findaplanforeach')}

</div>
<img src={ArtistDots1} style={{position:'absolute',width:'1.48em',height:'26.83em',top:'5em',left:'2em'}}/>
<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginTop:'3em',width:'80.89%'}}>

<div className='PlanBox' style={{maxWidth:'16.5em',height:'34em'}}>
    <div style={{display:'flex',alignItems:'center'}}>
        <img className='PlanBoxLogo' src={NervousLogo} alt="Red 4 sided star"/>
      </div>

  

    <div className='PlanBoxName' style={{width:'100%',fontSize:'1.5rem',fontWeight:'500'}}>{t('Nervous')}</div>

    <div className='PlanBoxPrice' style={{marginTop:'1.5em'}}>{t('Free')}</div>

  <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'90%'}}>
    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
      <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
      <div className='CheckListItem'>{t('Delivertosocial')}</div>
    </div>

    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
      <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
      <div className='CheckListItem'>{t('Limiteddsprelease')}</div>
    </div>

    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
      <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
      <div className='CheckListItem'>{t('Take90%royalty')}</div>
    </div>
  </div>

</div>


<div className='PlanBox' style={{maxWidth:'16.5em',borderTopLeftRadius:'0px',height:'34em',borderTopRightRadius:'0px',position:'relative'}}>
    {/* <div className='MostPopularTxt' >
      MOST POPULAR
    </div> */}
//     <div className="Mostpoptxt">
//     MOST POPULAR
//     </div>
//     <img className='PlanBoxLogo' src={NervousPlusLogo} alt="Red 4 sided star"/>

//     <div className='PlanBoxName' style={{width:'100%',fontSize:'1.5rem',fontWeight:'500'}}>{t('Nervousplus')}</div>

//     <span className='PlanBoxPrice' style={{marginTop:'1.5em'}}> 
//                 <Trans i18nKey="Nervousplusprice">
//                 $19.99
//                 <span className='PlanBoxPriceYrTxt'>/ year</span>
//     </Trans></span>

//   <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'90%'}}>
//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>
//       <Trans i18nKey="Includeallbenefits" components={{1:<br/>}} >
//       Includes all benefits<br/> from N3RVous
//     </Trans>
//   </div>

//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>{t('Brandyourself')}</div>
//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>{t('Take100%ofroyal')}</div>
//     </div>
//   </div>
  

  
// </div>

// <div className='PlanBox'  style={{maxWidth:'16.5em',height:'34em'}}>
//     <img className='PlanBoxLogo' src={NerveProLogo} alt="Red 4 sided star"/>

//     <div className='PlanBoxName' style={{width:'100%',fontSize:'1.5rem',fontWeight:'500'}}>{t('Nervepro')}</div>

//     <span className='PlanBoxPrice' style={{marginTop:'1.5em'}}> 
//                 <Trans i18nKey="Nerveproprice">
//                 $49.99
//                 <span className='PlanBoxPriceYrTxt'>/ year</span>
//                 </Trans></span>

//   <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'90%'}}>
//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',marginBottom:'0.5em',width:'90%'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'><Trans i18nKey="Includesallbenefits" components={{1:<br/>}} >
//       Includes all benefits<br/> from N3RVE 
//     </Trans></div>
//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',marginBottom:'0.5em',width:'90%'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>Unlimited DSP Release</div>
//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',marginBottom:'0.5em',width:'90%'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>{t('Youtubemonetize')}</div>
//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',marginBottom:'0.5em',width:'90%'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'><Trans i18nKey="Exclusivebrand" components={{1:<br/>}} >
//       Exclusive Brand/Sync<br/> Deals
//     </Trans></div>
//     </div>
//   </div>
  

// </div>

// <div className='PlanBox'  style={{maxWidth:'16.5em',height:'34em'}}>
//     <img className='PlanBoxLogo' src={InviteOnlyLogo} alt="Red 4 sided star"/>

//     <div className='PlanBoxName' style={{width:'100%',fontSize:'1.5rem',fontWeight:'500'}}>{t('Inviteonly')}</div>

//     <div className='PlanBoxPrice' style={{marginTop:'1.5em'}}>{t('Contactsales')}</div>

//   <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'90%'}}>
//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'><Trans i18nKey="Includedallbene" components={{1:<br/>}} >
//       Includes all benefits<br/> from N3RVE Premier
//     </Trans></div>
//     </div>

//     <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',width:'90%',alignItems:'center',marginBottom:'0.5em'}}>
//       <img style={{height:'1.25em', width:'1.25em'}} src={CheckCircle} alt="Check mark"/>
//       <div className='CheckListItem'>{t('Audienceengage')}</div>
//     </div>
//   </div>
  
// </div>

// <img src={ArtistDots3} style={{width:'0.241em',height:'4.75em',marginTop:'-18.8em',marginLeft:'1em'}}/>

// </div>
// <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'16.93em',height:'4em', marginTop:'2em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}  onClick={()=>setPlansPopup(true)}>
// <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
// <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
// <div className="Compareplansbtn">
// SEE ALL DETAILS

// </div>
// </div>

// </div> */}